
<div *ngIf="tests&&!selectedType" class="table-container">

        <div class="col-12">
          <div class="form-group row">

            <div class="col-12 col-md-6 px-0">
              <input [(ngModel)]="testFilter" (ngModelChange)="actualPage = 1" class="form-control custom-input" type="text" id="example-date-input" placeholder="Buscar">
              <span class="help-block">
                <small *ngIf="!viewMassive">Filtrar por email, nombre, prueba o etiquetas</small>
                <small *ngIf="viewMassive">Filtrar por nombre de formulario o etiqueta</small>
              </span>
            </div>
            <!-- <div class="col-12 col-md-3 pt-2">
              <div class="switch">
                <label>
                  <b>Pruebas</b>
                  <input [(ngModel)]="viewForms" type="checkbox"><span class="lever switch-col-indigo"></span>
                  <b>Formularios</b>
                </label>
              </div>
            </div> -->
            <div class="col-12 col-md-6 pt-3">
              <h4>

                <button *ngIf="!inTrash && !viewMassive" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect btn-sm pull-right btn-rounded" (click)="showTrash()">Ver papelera</button>
                <!-- <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect btn-sm pull-right btn-rounded mx-1" (click)="handleCreateReport()">Generar reporte</button> -->
                  <button *ngIf="inTrash" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect btn-sm pull-right btn-rounded" (click)="back()">Volver</button>
                  <div class="btn-tooltip mr-4">
                    <button type="button" class="btn btn-info waves-effect btn-sm btn-rounded" (click)="exportData()">Exportar datos de pruebas</button>
                    <label class="mytooltip button-tooltip pointer"><b class="text-info"><small><b>?</b></small></b>
                        <span class="tooltip-content4">
                            Exporta en un Excel los datos y resultados crudos de todos los evaluados.
                        </span>
                    </label>
                  </div>
                
                </h4>
            </div>

          </div>
        </div>

        <div *ngIf="!viewMassive" class="col-12 mb-4 card p-3">
            <h5>
                
                Carpetas
                <label class="mytooltip button-tooltip pointer"><b class="text-info"><small><b>?</b></small></b>
                    <span class="tooltip-content4">
                        Agrupa evaluados por área, equipo o proyecto usando carpetas.
                    </span>
                </label>
            </h5>
            <div class="row folders-container px-3">
                <div [ngClass]="folderFilter == '' ? 'folder-selected' : ''" class="folder" (click)="folderFilter = ''; actualPage = 1">
                    <i  class="fa fa-folder-o"></i>
                    <span><small>&nbsp;Sin carpeta</small></span>
                </div>
                <div *ngFor="let lfolder of folders" class="relative">
                    <div [ngClass]="folderFilter == lfolder._id ? 'folder-selected' : ''" class="folder" [ngStyle]="{backgroundColor: lfolder.color}" (click)="folderFilter = lfolder._id; actualPage = 1">
                        <i  class="fa fa-folder-o"></i>
                        <span><small>&nbsp;{{lfolder.name}}</small></span>
                    </div>
                    <small *ngIf="folderFilter == lfolder._id" class="edit-folder-btn" data-toggle="modal" data-target="#folderModal" (click)="editingFolderId = lfolder._id; folder = lfolder" ><i class="fa fa-pencil" ></i></small>
                </div>
                <div class="folder add-folder" data-toggle="modal" data-target="#folderModal">
                    <i  class="fa fa-plus-square-o"></i>
                    <span><small>&nbsp;Agregar nueva</small></span>
                </div>
            </div>
        </div>
        <div class="row jce mb-3">
          <div class="col-2">
            <div class="row jcc">
              <i [ngStyle]="{color : (domainService.customColor$ | async)}" class="fa fa-caret-left page-navigator" (click)="changePage(-1)"></i>
            </div>
          </div>
          <div class="col-8 col-md-2">
              <p class="text-center mb-0" *ngIf="!viewMassive"><b><small>Página {{actualPage}} de {{getPages((tests | folder : folderFilter | testFilter: testFilter).length).toFixed(0)}}</small></b></p>
              <p class="text-center mb-0" *ngIf="!viewMassive"><b><small>Total: {{(tests | folder : folderFilter | testFilter: testFilter).length}}</small></b></p>
              <p class="text-center mb-0" *ngIf="viewMassive"><b><small>Página {{actualPage}} de {{getPages((massiveData | massiveFilter: testFilter).length).toFixed(0)}}</small></b></p>
              <p class="text-center mb-0" *ngIf="viewMassive"><b><small>Total: {{((massiveData | massiveFilter: testFilter).length)}}</small></b></p>
            <!-- <div class="row jcc">
            </div> -->
          </div>
          <div class="col-2">
            <div class="row jcc">
              <i [ngStyle]="{color : (domainService.customColor$ | async)}" class="fa fa-caret-right page-navigator" (click)="changePage(1)"></i>
            </div>
          </div>
        </div>
        <div class="table-container2">
            <table *ngIf="!viewMassive" class="table tests-table" >
                <thead>
                    <tr>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" >Nombre</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class >Email del evaluado</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" (click)="ascending = !ascending; executeSort()" >Test</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Fecha de creación</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" >Etiquetas</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-180 text-center">Estado</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Acciones</th>
                        <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Reportes</th>
                    </tr>
                </thead>
                
                <tbody *ngIf="tests.length > 0">
                    <tr *ngFor="let test of tests | folder : folderFilter  | testFilter: testFilter | paginatorFilter: actualPage; index as i ">
                        <td class="footable-visible">{{test.evaluatedName}}&nbsp;<span *ngIf="test.camera" class="text-danger pull-right">Requiere cámara</span></td>
                        <td class="footable-visible">{{test.isLocal ? 'Evaluado localmente' : test.evaluated}}</td>
                        <td *ngIf="test.type=='KOSTIK'">KOSTICK</td>
                        <td *ngIf="test.type=='ALL PORT'">ALLPORT</td>
                        <td *ngIf="test.type=='BIS11'">BIS-11</td>
                        <td *ngIf="test.type=='FORMULARIO'">{{test.completeForm.title}}</td>
                        <td *ngIf="test.type!='KOSTIK'&&test.type!='FORMULARIO'&&test.type!='ALL PORT'&&test.type!='BIS11'">{{(test.type!='MMPI2'&&test.type!='MMPIA')?test.type:'' }}{{test.type=='MMPI2'&&test.extra=="Abreviado"?'MMPI-2 - (Abreviado)':''}}{{test.type=='MMPI2'&&test.extra!="Abreviado"?'MMPI-2 - (Extendido)':''}}{{test.type=='MMPIA'&&test.extra=="Abreviado"?'MMPI-A - (Abreviado)':''}}{{test.type=='MMPIA'&&test.extra!="Abreviado"?'MMPI-A - (Extendido)':''}} <span *ngIf="test.useCleaverHF" ><b>+ FH</b></span></td>
                        <td class="footable-visible text-center">{{test.createDate | date:'mediumDate'}}</td>
                        <td class="w-180"><span *ngFor="let tag of test.tags; index as j" class="label label-rounded mr-1 pointer" [ngStyle]="{'background-color': tag.color}" (click)="removeTag(test, j)" >{{tag.name}}</span><i title="Agregar nueva" class="mt-1 fa fa-plus pointer" (click)="addTag(test)"></i></td>
                        <td *ngIf="test.isCompleted" class="footable-visible text-center">
                            <span class="label label-success label-rounded ">Realizado</span> 
                            <a *ngIf="test.camera" class="text-info" (click)="viewPhoto(test.cameraUrl)" href="javascript:void(0)"><span>&nbsp;<b><small><b>Ver foto</b></small></b></span></a>
                        </td>
                        <td *ngIf="!test.isCompleted&&!test.isStarted" class="footable-visible text-center"><span class="label label-danger label-rounded">Pendiente</span></td>
                        <td *ngIf="!test.isCompleted&&test.isStarted" class="footable-visible text-center">
                            <span class="label label-warning label-rounded">Usuario bloqueado</span>
                            <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline" title="Desbloquear" (click)="reloadTest(test)" ><i class="fa fa-lock" ></i></button>
                        </td>
                        <td class="footable-visible footable-last-column text-center px-0 ">
                            <button *ngIf="test.type=='CLEAVER'" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleOpenHf(test)" title="Formulario factor humano" ><i class="fa fa-briefcase" ></i></button>
                            <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " data-toggle="modal" (click)="selectingFolderId = test.path; editingFolderTestId = test._id" data-target="#selectFolderModal" title="Seleccionar carpeta"><i class="fa fa-folder-o" ></i></button>
    
                            <button *ngIf="test.isLocal && !test.isCompleted" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Iniciar prueba local" (click)="execute(test)" ><i class="fa fa-book" ></i></button>
                            <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Editar" data-toggle="modal" data-target=".editModal" (click)="handleEdit(test.evaluated)" ><i class="fa fa-pencil" ></i></button>
                            <!-- <button *ngIf="test.isCustomTest" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Ruta de Progresión Personal" [routerLink]="['/dashboard/custom-test-history']" [queryParams]="{testId: test.completeForm, userEmail: test.evaluated}" ><i class="fa fa-line-chart" ></i></button> -->
                            <button *ngIf="!test.trash" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Enviar a la papelera" (click)="trash(test)" ><i class="fa fa-trash-o"></i></button>
                            <button *ngIf="test.trash" type="button" class="btn btn-sm btn-icon btn-pure btn-outline " title="Restaurar" (click)="trash(test)" ><i class="fa fa-backward"></i></button>
                            <button *ngIf="!test.isCompleted && !test.isStarted" type="button" class="btn btn-sm btn-icon btn-pure btn-outline text-danger" title="Eliminar" (click)="deleteTest(test)" ><i class="fa fa-times" ></i></button>
                            <div *ngIf="test.isCompleted" class="row justify-content-center form-actions">
        
                                <a *ngIf="test.public" class="btn-success btn-rounded btn-sm text-white mytooltip mx-1" href="javascript:void(0)" style="z-index: 999;" (click)="changeVisibility(test)">Público<span class="tooltip-content4">Este reporte es público. Lo podrá visualizar cualquiera con quien comparta el link.</span></a>
                                <a *ngIf="!test.public" class="btn-danger btn-rounded btn-sm text-white mytooltip mx-1" href="javascript:void(0)" style="z-index: 999;" (click)="changeVisibility(test)">Privado<span class="tooltip-content4">Este reporte es privado. No podrá ser visualizado aunque se comparta el link.</span></a>
        
                            </div>                    
    
                        </td>
    
                        <td class="footable-visible footable-last-column text-center px-1 w-150">
                          <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded" title="Ver/Compartir" [disabled]="!test.isCompleted" (click)="test.type!='FORMULARIO'?viewTest(test):viewForm(test)" ><b>Online</b></button>&nbsp;
                          
                          <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded" title="Ver/Exportar" [disabled]="!test.isCompleted" (click)="test.type!='FORMULARIO'?viewTest(test, true):viewForm(test, true)" ><b>PDF</b></button>
                          <button *ngIf="test.isCustomTest && haveMoreThanOneTest(test.type, test.evaluated)" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded mt-1" [routerLink]="['/dashboard/custom-test-history']" [queryParams]="{testId: test.completeForm, userEmail: test.evaluated}" ><b>Progresión</b></button>&nbsp;
                        </td>
                    </tr>
                </tbody>
                
            </table>
    
    
            <table *ngIf="viewMassive" class="table tests-table" >
              <thead>
                  <tr>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" >Nombre de formulario</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center w-180" >Etiqueta</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Fecha de creación</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Puntaje de parobación</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Es excluyente</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="text-center" >Usuarios totales</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Realizados</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" >Pendientes</th>
                      <th [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="w-130 text-center">Reportes</th>
                  </tr>
              </thead>
              
              <tbody *ngIf="massiveData.length > 0">
                  <tr *ngFor="let test of massiveData | massiveFilter: testFilter | paginatorFilter: actualPage; index as i ">
                      <td class="footable-visible">{{test[0].formName}}</td>
                      <td class="footable-visible w-180 text-center"> <span class="label label-rounded mr-1 pointer" [ngStyle]="{'background-color': test[0].tagColor}">{{test[0].tag}}</span></td>
                      <td class="footable-visible text-center">{{test[0].test.createDate | date: 'dd/MM/yyyy'}}</td>
                      <td class="footable-visible text-center">{{test[0].test.completeForm.aprovationScore}}</td>
                      <td class="footable-visible text-center">{{test[0].test.completeForm.exclude ? 'SI' : 'NO'}}</td>
                      <td class="footable-visible pointer text-center" (click)="showUsers('total', i)"><b>{{test.length}}</b></td>
                      <td class="footable-visible pointer text-center text-success text-bold" (click)="showUsers('completed', i)">{{getCompletedFormsCount(test)}}</td>
                      <td class="footable-visible pointer text-center text-danger text-bold" (click)="showUsers('pending', i)">{{getIncompletedFormsCount(test)}}</td>
    
                      <td class="footable-visible footable-last-column text-center px-1 w-150">
                        <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" type="button" class="btn label label-info label-rounded" title="Ver/Exportar" (click)="filterTest = test[0].formName; filteredTags = [test[0].tag]; generateFormReport()" ><b>Ver/Exportar</b></button>&nbsp;
                      </td>
                  </tr>
              </tbody>
              
          </table>

        </div>

</div>


<div *ngIf="selectedHfTest" id="hfModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">Formulario factor humano</h4>

                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body p-5">
                <app-cleaver-hf-form [test]="selectedHfTest" (saved)="closeHfModal()" ></app-cleaver-hf-form>
            </div>

        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>


<div id="folderModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">{{editingFolderId ? 'Actualizar' : 'Crear'}} carpeta</h4>

                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <input [(ngModel)]="folder.name" class="form-control custom-input" type="text" id="example-date-input" placeholder="Nombre">
                <span class="help-block">
                <small>Nombre de la carpeta</small>
                <div class="col-3 px-0">
                    <input [(ngModel)]="folder.color" class="form-control custom-input mt-4" type="color" id="example-date-input" placeholder="Color">
                    <small>Color</small>

                </div>


              </span>
              <div class="col-12 mt-3">
                  <button type="button" class="btn btn-info waves-effect pull-right btn-rounded mx-3" (click)="createFolder()" >{{editingFolderId ? 'Actualizar' : 'Crear'}}</button>
                  <button *ngIf="editingFolderId" type="button" class="btn btn-danger waves-effect pull-right btn-rounded mx-3" (click)="handleDeleteFolder(editingFolderId)" >Eliminar carpeta</button>

              </div>
            </div>

        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div id="selectFolderModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">Seleccionar carpeta</h4>

                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">


                <select class="form-control" [(ngModel)]="selectingFolderId">
                    <option  value="">Sin carpeta</option>
                    <option *ngFor="let folder of folders" [value]="folder._id">{{folder.name}}</option>
                </select>
                <span class="help-block text-muted"><small>Seleccionar carpeta</small></span>


              <div class="col-12 mt-3">
                  <button type="button" class="btn btn-info waves-effect pull-right btn-rounded mx-3" (click)="updateTestFolder()" >Actualizar</button>

              </div>
            </div>

        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div *ngIf="selectedTest" class="row m-b-20">
    
    <button *ngIf="selectedType && user" class="btn btn-danger btn waves-effect btn-rounded pull-left m-r-5" (click)="back()">Atrás</button>
    <button style="margin-left: auto;" class="btn btn-success waves-effect btn btn-rounded m-r-5" (click)="generatePdf()"> Exportar a PDF</button>
    <button *ngIf="selectedType != 'FORMULARIOREPORT'" class="btn btn-primary waves-effect btn btn-rounded m-r-5" (click)="share()" > Compartir reporte</button>
    <a *ngIf="selectedType == 'MIPS'" class=" btn btn-primary waves-effect btn btn-rounded" href="../../../assets/files/Instrucciones-mips.pdf" download="Guía MIPS.pdf">Descargar guía en PDF</a>

</div>

<div class="row justify-content-center">

    <!-- FORMULARIO -->


      <div *ngIf="selectedType=='FORMULARIO'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>{{selectedTest.completeForm.title }}</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Puntaje de aprobación: </b></strong><b class="text-gray f-bold">{{selectedTest.completeForm.aprovationScore}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Resultado: </b></strong><b class="text-gray f-bold">{{selectedTest.formScore}}</b></p>
                </div>

                
            </div>

        </div>


        <div id="contentToExport4" #contentToExport4 >
        
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div class="row justify-content center">
              <div *ngFor="let field of testData.formModel; index as i" class="col-md-12">
                  <div>
                      <p class="mb-1"><small><b>{{i + 1}} - {{field.text}}</b> <span class="points-label">{{getQuestionScore(i)}}</span></small></p>
                      <p><small>{{getTextResponse(testData.formData[i])}}</small></p>
                  </div>
              </div>
          </div>
        </div>

        <div id="contentToExport5" #contentToExport5 class="p-30"></div>
        

        
    </div>


      <!-- FORMULARIO REPORTE-->


      <div *ngIf="selectedType=='FORMULARIOREPORT'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>Reporte de {{filterTest}}</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>

        <div id="contentToExport4" class="mt-5" #contentToExport4 >
        
            <div class="row justify-content center mt-5 pt-5">
              <div class="col-md-12 mt-5">
                  <div>
                    <table class="report-table">
                      <tr>
                        <th>
                          <small><b>Nombre y apellido</b></small>
                        </th>
                        <th class="text-center">
                          <small><b>Fecha de creación</b></small>
                        </th>
                        <th class="text-center">
                          <small><b>Puntaje</b></small>
                        </th>
                        <th class="text-center">
                          <small><b>Puntaje de aprobación</b></small>
                        </th>
                        <th class="text-center">
                          <small><b>Estado</b></small>
                        </th>
                      </tr>
                      <tr *ngFor="let report of testsForReport; index as i">
                        <td>
                          <small>{{report.evaluatedName}}</small>
                        </td>
                        <td class="text-center">
                          <small>{{report.createDate | date:'dd/MM/yyyy'}}</small>
                        </td>
                        <td class="text-center">
                          <small>{{report.formScore}}</small>
                        </td>
                        <td class="text-center">
                          <small>{{report.completeForm.aprovationScore}}</small>
                        </td>
                        <td class="text-center">
                          <img *ngIf="report.formScore >= report.completeForm.aprovationScore" src="../../../assets/images/icon/thumb-up.png" alt="" class="thumb-icon">
                          <img *ngIf="report.formScore < report.completeForm.aprovationScore" src="../../../assets/images/icon/thumb-down.png" alt="" class="thumb-icon">
                        </td>
                      </tr>
                    </table>
                  </div>
              </div>
              <div class="col-12">
                <h3 class="mt-4 custom-title mb-4">
                  <b>Guía del formulario</b>
                </h3>
                <div class="row justify-content center">
                  <div *ngFor="let field of testData.formModel; index as i" class="col-md-12">
                      <div>
                          <p class="mb-1"><small><b>{{i + 1}} - {{field.text}}</b></small></p>
                      </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div id="contentToExport5" #contentToExport5 class="p-30"></div>
        

        
    </div>


    <!-- 16PF -->

    <div *ngIf="selectedType=='16PF'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST 16 PF</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>

                
            </div>
            <div class="description-section" #pfReport></div>

        </div>
        <div id="contentToExport2" #contentToExport2 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row ">
                <div class="col-md-12">
                    <h4 *ngIf="report" class="text-primary"><b>Factor de distorsión D: {{report.score.D}}</b></h4>
                    <p *ngIf="report && report.score.D <= 8" class="text-gray f-bold">Sirve para detectar a los sujetos que intentan ofrecer una buena imagen de sí mismos. En este caso la calificación es adecuada, es sincero, ya que se encuentra en un rango dentro del promedio. </p>
                    <p *ngIf="report && report.score.D >= 9" class="text-gray f-bold">Tendencia a mostrarse en la forma más favorable posible, los resultados no son confiables. En este caso la calificación muestra que ha querido mostrarse con un perfil mejor de lo que realmente es a fin de agradar. </p>
                    <div id="pfChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptions"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>
        </div>
        <div style="justify-content: center;" id="contentToExport3" #contentToExport3 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>
            <div class="row justify-content-center">
        
                <div *ngFor="let f of pf16Array; index as i" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-md-2 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" [src]="f.high?'../../../assets/images/level/6.png':'../../../assets/images/level/2.png'" alt="">
                                    </div>
                                </div>
                                <div class="col-12">
                                    <h4 [ngClass]="f.high ? 'text-high' : 'text-low'" class="m-b-0 text-center"><b>{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-10">
                            <p class="text-gray f-bold"><b>&#9632; {{f.desc}}</b></p>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div id="contentToExport4" #contentToExport4 >
        
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-2 col-sm-3 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> {{r}}</small></h5>
                </div>
            </div>
        </div>

        <div id="contentToExport5" #contentToExport5 class="p-30"></div>
        

        
    </div>

        <!--////ALL PORT////--->


    <div *ngIf="selectedType=='ALL PORT'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST ALLPORT</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div id="contentToExport" #contentToExport class="mt-5 pt-5">

            <div *ngIf="evaluated&&report" class="mt-5 mb-4 row profile-data">

                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
 
            </div>
            <div class="description-section" #allPortReport></div>

            <div class="row">
                <div class="col-12 mb-4 mt-4">
                    <h3 class="custom-title sm-font">
                        <img src="../../../assets/images/icon/goals.svg" alt="" class="svg-primary">
                        <b>AUTODESCRIPCIÓN Y METAS</b>
                    </h3>
        
                </div>
    
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Es una persona que se describe como: </b></strong><b class="text-gray f-bold">{{report.form[1]}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Siente gran aprecio por: </b></strong><b class="text-gray f-bold">{{report.form[2]}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Lo que mas le disgusta: </b></strong><b class="text-gray f-bold">{{report.form[3]}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Tiene como metas personales y profesionales: </b></strong><b class="text-gray f-bold">{{report.form[4]}}</b></p>
                </div>                   
            </div>    
        </div>
        <div id="contentToExport2" #contentToExport2 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
            
                <div class="col-md-12">
                    <div id="allPortChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsAllPort"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/table.svg" alt="" class="svg-primary">
                <b>TABLA DE PERFIL</b>
            </h3>
            <div class="">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="f-bold text-gray">VALOR</th>
                            <th class="f-bold text-gray text-center">PUNTUACIÓN</th>
                            <th class="text-center f-bold text-gray" >NIVEL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let v of allPortArray">
                            <td class="f-bold text-primary">{{v.title}}</td>
                            <td class="f-bold text-gray text-center">{{v.value}}</td>
                            <td [ngSwitch]="v.color">
                                <div *ngSwitchCase="'red'" class="row">
                                    <div class="col-12">
                                        <div class="row jcc">
                                            <div class="col-12">
                                                <div class="row jcc">
                                                    <img class="img-xsm img-sm" src="../../../assets/images/level/2.png" alt="">
                                                </div>
                                            </div>
                                            <span class="f-bold text-low">BAJO</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngSwitchCase="'yellow'" class="row">
                                    <div class="col-12">
                                        <div class="row jcc">
                                            <div class="col-12">
                                                <div class="row jcc">
                                                    <img class="img-xsm img-sm" src="../../../assets/images/level/4.png" alt="">
                                                </div>
                                            </div>
                                            <span class="f-bold text-mid">MEDIO</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngSwitchCase="'green'" class="row">
                                    <div class="col-12">
                                        <div class="row jcc">
                                            <div class="col-12">
                                                <div class="row jcc">
                                                    <img class="img-xsm img-sm" src="../../../assets/images/level/6.png" alt="">
                                                </div>
                                            </div>
                                            <span class="f-bold text-high">ALTO</span>
                                        </div>
                                    </div>
                                </div>

                            </td>

                        </tr>

                    </tbody>
                </table>
            </div>
        </div>    

        <div id="contentToExport3" #contentToExport3 >
        
            <h3 class="mt-4 custom-title mb-5 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>


            <div *ngFor="let f of allPortArray">
                <h4 class="question-container">
                    <span class="question-number">{{f.title}}</span>
                </h4>
                <p class="f-bold text-gray">{{f.desc}}</p>
            </div>

        </div>
        <div id="contentToExport4" #contentToExport4 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>      
            <h4 class="m-b-20 text-primary"><b>CUESTIONARIO 1</b></h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of answers1AllPort; index as i" class="col-12 col-md-6 mb-3">
                    <h5 >
                        <small class="question-container-r">
                            <span class="question-number-r">Nº {{i+1}}</span>
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==3" class="text-center text-gray"> Totalmente de acuerdo con A </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==0" class="text-center text-gray"> Totalmente de acuerdo con B </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==2" class="text-center text-gray"> Ligera preferencia por A </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==1" class="text-center text-gray"> Ligera preferencia por B </span> 
                            <span *ngIf="r[3]>0&&r[4]>0" class="text-center text-gray">A: {{r[1]}} B: {{r[2]}} C: {{r[3]}} D: {{r[4]}} </span> 
                        </small>
                    </h5>


                </div>
            </div>
        </div>
        <div id="contentToExport5" #contentToExport5 >

            <h4 class="m-b-20 text-primary"><b>CUESTIONARIO 2</b></h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of answers2AllPort; index as i" class="col-12 col-md-6 mb-3">
                    <h5 >
                        <small class="question-container">
                            <span class="question-number">Nº {{i+1}}</span>
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==3" class="text-center text-gray"> Totalmente de acuerdo con A </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==0" class="text-center text-gray"> Totalmente de acuerdo con B </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==2" class="text-center text-gray"> Ligera preferencia por A </span> 
                            <span *ngIf="(r[3]==0&&r[4]==0)&&r[1]==1" class="text-center text-gray"> Ligera preferencia por B </span> 
                            <span *ngIf="r[3]>0&&r[4]>0" class="text-center text-gray"> A: {{r[1]}} B: {{r[2]}} C: {{r[3]}} D: {{r[4]}} </span> 
                        </small>
                    </h5>
                </div>
            </div>
        </div>
    </div>

    <!--BARSIC-->


    <div *ngIf="selectedType=='BARSIC'" class="card col-md-10 col-lg-8 p-4 p-md-5">

        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST BARSIT</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >

            <div *ngIf="evaluated&&report" class="mt-5 mb-4 row profile-data">
                
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
            
            </div>
            <div class="description-section" #barsicReport></div>

        </div>
        <div id="contentToExport2" #contentToExport2 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
            
                <div class="col-md-12">
                    <div id="barsicChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [height]="250"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsBarsic"
                        [legend]="barChartLegend"
                        [plugins]="barChartPlugins"
                        [chartType]="barChartType"
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>
            <div *ngIf="barsicScores" class="row">
                <div class="col-md-6 mb-4">
                    <h4 class="question-container">
                        <span class="question-number">Valores obtenidos</span>
                    </h4>

                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="f-bold text-primary">Serie</th>
                                    <th class="f-bold text-primary text-center">Aciertos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-gray f-bold">Información</td>
                                    <td [ngClass]="barsicArray[0]?.level <= 2 ? 'text-low' : barsicArray[0]?.level <= 5 ? 'text-mid' : 'text-high'" class="text-center f-bold">
                                        <div class="row jcc"><img class="level-img img-xsm" [src]="'../../../assets/images/level/'+barsicArray[0]?.level+'.png'" alt=""></div>
                                        {{barsicScores.informacion}}
                                    </td>         
                                </tr>
                                <tr>
                                    <td class="text-gray f-bold">Razonamiento verbal</td>
                                    <td [ngClass]="barsicArray[1]?.level <= 2 ? 'text-low' : barsicArray[1]?.level <= 5 ? 'text-mid' : 'text-high'" class="text-center f-bold">
                                        <div class="row jcc"><img class="level-img img-xsm" [src]="'../../../assets/images/level/'+barsicArray[1]?.level+'.png'" alt=""></div>
                                        {{barsicScores.razonamientoVerbal}}
                                    </td>         
                                </tr>
                                <tr>
                                    <td class="text-gray f-bold">Comprensión de vocabulario</td>
                                    <td [ngClass]="barsicArray[2]?.level <= 2 ? 'text-low' : barsicArray[2]?.level <= 5 ? 'text-mid' : 'text-high'" class="text-center f-bold">
                                        <div class="row jcc"><img class="level-img img-xsm" [src]="'../../../assets/images/level/'+barsicArray[2]?.level+'.png'" alt=""></div>
                                        {{barsicScores.comprensionDeVocabulario}}
                                    </td>         
                                </tr>
                                <tr>
                                    <td class="text-gray f-bold">Razonamiento lógico</td>
                                    <td [ngClass]="barsicArray[3]?.level <= 2 ? 'text-low' : barsicArray[3]?.level <= 5 ? 'text-mid' : 'text-high'" class="text-center f-bold">
                                        <div class="row jcc"><img class="level-img img-xsm" [src]="'../../../assets/images/level/'+barsicArray[3]?.level+'.png'" alt=""></div>
                                        {{barsicScores.razonamientoLogico}}
                                    </td>         
                                </tr>
                                <tr>
                                    <td class="text-gray f-bold">Razonamiento numérico</td>
                                    <td [ngClass]="barsicArray[4]?.level <= 2 ? 'text-low' : barsicArray[4]?.level <= 5 ? 'text-mid' : 'text-high'" class="text-center f-bold">
                                        <div class="row jcc"><img class="level-img img-xsm" [src]="'../../../assets/images/level/'+barsicArray[4]?.level+'.png'" alt=""></div>
                                        {{barsicScores.razonamientoNumerico}}
                                    </td>         
                                </tr>
                                <tr >
                                    <td class="text-primary f-bold">Total</td>
                                    <td class="text-gray text-center f-bold">{{barsicScores.razonamientoNumerico+barsicScores.razonamientoLogico+barsicScores.comprensionDeVocabulario+barsicScores.razonamientoVerbal+barsicScores.informacion}} de 60</td>         
                                </tr>
    
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="col-md-6">
                    <h4 class="question-container">
                        <span class="question-number">Escolaridad </span>
                    </h4>
                    <span class="text-primary f-bold">{{report.scholarship.toUpperCase()}}</span>
                    <h4 class="question-container mt-4">
                        <span class="question-number">Rango </span>
                    </h4>
                    <span class="text-primary f-bold">{{barsicRange}}</span>
                </div>

            </div>
        </div>
        <div id="contentToExport3" #contentToExport3 >

            <h3 class="mt-4 custom-title mb-5 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>

            <div class="row">

                <div *ngFor="let f of barsicArray" class="col-12">
                    <h4 class="question-container">
                        <span class="question-number">{{f.title}}</span>
                    </h4>
                    <p class="f-bold text-gray">{{f.desc}}</p>

                </div>
            </div>

        </div>
        <div id="contentToExport4" #contentToExport4 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <span class="custom-danger f-bold "><span style="font-size: 26px;">&#9632;</span> = Incorrecto</span>
            <div *ngIf="report" class="row mt-3">
                <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-3 col-sm-3 mb-3">
                    <h5 ><small class="question-container-r" [ngClass]="report.correctsArray[i]==1?'':'custom-error-border'"><span class="question-number-r" [ngClass]="report.correctsArray[i]==1?'':'custom-error'">Nº {{i+1}}</span> {{r}}</small></h5>
<!-- 
                    <div class="card" [ngClass]="report.correctsArray[i]==1?'card-outline-info min-margin-bottom':'card-outline-danger min-margin-bottom'">
                        <div style="max-height: 30px; padding: 5px;" class="card-header">
                            <h5 class="m-b-0 text-white text-center"><small>Nº {{i+1}}</small></h5></div>
                        <div style="max-height: 30px; padding: 5px;" class="card-body">
                            <p class="card-text text-center">{{r}} </p> 

                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div id="contentToExport5" #contentToExport5 class="p-30"></div>

    </div>


    <!--CLEAVER-->


    <div *ngIf="selectedType=='CLEAVER'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >
            <div class="test-title">
                <h1 class="m-b-20 text-center text-white"><b>TEST CLEAVER</b></h1>
                <div class="divider">
                    <img src="../../../assets/images/waves.svg" alt="">
                </div>
            </div>

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
                
                
            

            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-4 px-0">
                        <h3 class="custom-title">
                            <b>INTRODUCCIÓN</b>
                        </h3>
                    </div>
                    <div class="description-section" #cleaverReport></div>
        
                </div>
        
        
                <div class="row mt-5">
                    <div class="col-12 mb-4 px-0">
                        <h3 class="custom-title">
                            <b>VALIDEZ</b>
                        </h3>
                    </div>
        
                    <p> La sumatoria de los resultados de T debe estar entre -3 y +3. Si esto no ocurre los resultados no pueden considerarse válidos.</p>
                    <p><b>¿Qué hacer cuando es inválida? </b></p>
                    <p>Se recomienda volver a aplicar la prueba, asegurándose de que la persona haya comprendido correctamente las instrucciones y el significado de todas las palabras incluidas. El sistema ofrece definiciones disponibles durante la evaluación, para que el evaluado pueda consultarlas en caso de duda. </p>
                    <p>Si después de 3 aplicaciones sigue resultando inválida, se sugiere usar otro instrumento de medición. La caducidad de esta prueba es de 6 meses a partir de la fecha de aplicación.</p>
                    <div *ngIf="isCleaverValid" class="card-green my-3">
                        <h3 class="text-white text-center mb-0"><b>El perfil es válido</b></h3>
                    </div>
                    <div *ngIf="!isCleaverValid">
                        <div class="card-red my-3">
                            <h3 class="text-white"><b>No tomes en cuenta perfiles de este tipo.</b></h3>
                            <p class="text-white"><b>Recuérdale al candidato que debe disponer de tiempo y un ambiente tranquilo para pruebas.</b></p>
                        </div>
                        <div id="cleaverInvalidChart" class="row">
                            
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart1" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverFlatData"
                                        [labels]="barChartLabels3"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart2" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverDepressData"
                                        [labels]="barChartLabels"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                            
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart3" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverExtremeData"
                                        [labels]="barChartLabels2"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                            
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
        
        
                        </div>
        
                        <div id="cleaverInvalidChart2" class="row">
                            
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart1" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverElevatedData"
                                        [labels]="barChartLabels3"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart2" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverTenseData"
                                        [labels]="barChartLabels"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                            
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
                            <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                            
                                <div *ngIf="lineChartData.length>0" class="col-md-12">
                                    <div id="cleaverChart3" style="display: block">
                                    <canvas baseChart
                                        [datasets]="cleaverApatheticData"
                                        [labels]="barChartLabels2"
                                        [options]="barChartOptionsCleaver"
                                        [legend]="barChartLegend"
                                        [chartType]="lineChartType"
                                        [height]="300"
                            
                                        >
                                    </canvas>
                                    </div>
                                </div>
                            
                            </div>
        
        
                        </div>

                        <section>
                            <h3>1. Perfiles Aplanados (Percentil 40-60)</h3>
                            <ul>
                                <li>No corresponden a la situación real.</li>
                                <li>No tienen una buena riqueza de información.</li>
                                <li>El evaluado podría no haber comprendido adecuadamente la prueba o algunas palabras.</li>
                                <li>No hay información suficiente para poder interpretar de manera adecuada.</li>
                            </ul>
                        
                            <h3>2. Aplanamiento en T</h3>
                            <p>Cuando se observa un aplanamiento en la escala T, se interpretarán M y L por separado.</p>
                        
                            <h3>3. Aplanamiento en L</h3>
                            <p>Un aplanamiento en la escala L puede indicar:</p>
                            <ul>
                                <li>Confusión debido al estilo de ser del evaluado.</li>
                                <li>La persona se encuentra en una etapa de cambio personal o profesional.</li>
                            </ul>
                        
                            <h3>4. Aplanamiento en M, T y L</h3>
                            <p>Cuando las escalas M, T y L están aplanadas:</p>
                            <ul>
                                <li>Puede haber confusión o ambivalencia en las respuestas.</li>
                                <li>Posible confusión de conceptos debido a la interpretación de las palabras.</li>
                                <li>El evaluado no sabe cuál opción elegir.</li>
                            </ul>
                        
                            <h3>5. Aplanamiento en M</h3>
                            <p>Cuando la escala M está aplanada, esto puede indicar que la persona:</p>
                            <ul>
                                <li>No sabe cómo quisiera ser o cómo debe ser en determinadas situaciones.</li>
                            </ul>
                        
                            <h3>6. Escalas por encima del Percentil 50 en M, L y/o T</h3>
                            <p>Cuando las escalas M, L y/o T están por encima del Percentil 50:</p>
                            <ul>
                                <li>Esto podría reflejar una angustia o un alto nivel de estrés en el evaluado.</li>
                            </ul>
                        
                            <h3>7. Escalas por debajo del Percentil 50</h3>
                            <p>Cuando las escalas están por debajo del Percentil 50:</p>
                            <ul>
                                <li>El evaluado puede haber experimentado presión durante la prueba.</li>
                            </ul>
                        </section>
                    
                    
                    
                    </div>
        
        
                </div>

            </div>

            <div *ngIf="selectedTest && selectedTest.useCleaverHF" >
                <h3 class="mt-4 custom-title mb-3 mt-5">
                    <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>FACTOR HUMANO</b>
                </h3>

                <div id="hfHtml" #hfHtml ></div>


                <div class="row mt-5">
                    <div class="col-md-8">
                        <h4 class="question-container">
                            <span class="question-number">PERFIL SOLICITADO</span>
                        </h4>
                        <div class="mt-4">
                            <table class="custom-table border-table">
                                <thead>
                                    <tr>
                                        <th class="f-bold text-primary"></th>
                                        <th class="f-bold text-primary text-center"> <small>Puntaje crudo</small><br> R</th>
                                        <th class="f-bold text-primary text-center"><small>Promedio</small><br> A</th>
                                        <th class="f-bold text-primary text-center"><small>Desviación<br></small> D <small>(R - A)</small></th>
                                        <th class="f-bold text-primary text-center">D%<br> <small>(X - D)</small></th>
                                        <th class="f-bold text-primary text-center"><small>Puntaje<br> D%</small> - 50 <small>(Graficar)</small></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="f-bold text-primary">D</td>
                                        <td class="f-bold text-gray">{{hfR.d}}</td>         
                                        <td class="f-bold text-gray">{{(hfR.d + hfR.i + hfR.s + hfR.c) / 4}}</td>         
                                        <td class="f-bold text-gray">{{hfD.d}}</td>         
                                        <td class="f-bold text-gray">{{hfDP.d}}</td>         
                                        <td class="f-bold text-gray">{{hf.d}}</td>         
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">I</td>
                                        <td class="f-bold text-gray">{{hfR.i}}</td>         
                                        <td class="f-bold text-gray">{{(hfR.d + hfR.i + hfR.s + hfR.c) / 4}}</td>         
                                        <td class="f-bold text-gray">{{hfD.i}}</td>         
                                        <td class="f-bold text-gray">{{hfDP.i}}</td>         
                                        <td class="f-bold text-gray">{{hf.i}}</td>          
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">S</td>
                                        <td class="f-bold text-gray">{{hfR.s}}</td>         
                                        <td class="f-bold text-gray">{{(hfR.d + hfR.i + hfR.s + hfR.c) / 4}}</td>         
                                        <td class="f-bold text-gray">{{hfD.s}}</td>         
                                        <td class="f-bold text-gray">{{hfDP.s}}</td>         
                                        <td class="f-bold text-gray">{{hf.s}}</td>          
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">C</td>
                                        <td class="f-bold text-gray">{{hfR.c}}</td>         
                                        <td class="f-bold text-gray">{{(hfR.d + hfR.i + hfR.s + hfR.c) / 4}}</td>         
                                        <td class="f-bold text-gray">{{hfD.c}}</td>         
                                        <td class="f-bold text-gray">{{hfDP.c}}</td>         
                                        <td class="f-bold text-gray">{{hf.c}}</td>          
                                    </tr>
        
        
                                </tbody>
                            </table>
                        </div>
                        <h4 class="mt-4"><b>Perfil solicitado: {{hfProfile}}</b></h4>
                        <div *ngIf="hfProfile != evaluatedHfProfile && hfProfile != 'Perfil no identificado'" class="card-red mt-2">
                            <p class="text-white mb-0"><b>El perfil evaluado no es compatible con el perfil solicitado</b></p>
                        </div>
                        <div *ngIf="hfProfile == evaluatedHfProfile && hfProfile != 'Perfil no identificado'" class="card-green mt-2">
                            <p class="text-white mb-0"><b>El perfil evaluado es compatible con el perfil solicitado</b></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div id="cleaverChartHf" style="display: block">
                            <canvas baseChart
                                [datasets]="cleaverHfData"
                                [labels]="barChartLabels3"
                                [options]="barChartOptionsCleaver"
                                [legend]="barChartLegend"
                                [chartType]="lineChartType"
                                [height]="300"
                                >
                            </canvas>
                            <p class="text-center mb-1"><b><small><b>Descripción del puesto</b></small></b></p>
                            <p class="text-center" ><small>Percepción: Jefe-Empleado</small></p>
                        </div>
                    </div>
                </div>

                <div id="hfProfileHtml" class="mt-3" #hfProfileHtml ></div>

                <div id="contentToExportFhAns" #contentToExportFhAns >

                    <h3 class="mt-5 custom-title mb-4">
                        <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>Escalas del perfil solicitado: Descripción del puesto</b>
                    </h3>
                    <div *ngIf="selectedTest.cleaverHfResult" class="row">
                        <div *ngFor="let r of selectedTest.cleaverHfResult; index as i" class="col-6 col-md-4 col-sm-4 mb-3">
                            <h5 >
                                <small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> 
                                    <span class="card-text text-center">&nbsp;{{hrFormData[i].factor}}: {{r}} </span> 
                                </small>
                            </h5>
                        </div>
                    </div>

                </div>

            </div>

            <div id="contentToExport2" #contentToExport2 >


                <h3 class="mt-4 custom-title mb-4">
                    <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>PERFIL GRÁFICO</b>
                </h3>

                <div id="cleaverChart" class="row">
                    
                    <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                    
                        <div *ngIf="lineChartData.length>0" class="col-md-12">
                            <div id="cleaverChart1" style="display: block">
                                <canvas baseChart
                                    [datasets]="lineChartData3"
                                    [labels]="barChartLabels3"
                                    [options]="barChartOptionsCleaver"
                                    [legend]="barChartLegend"
                                    [chartType]="lineChartType"
                                    [height]="300"
                                    >
                                </canvas>
                                <p class="text-center mb-1"><b><small><b>Comportamiento natural en el puesto</b></small></b></p>
                                <p class="text-center" ><small>Es la fusión de las limitaciones y motivación.</small></p>
                            </div>
                        </div>
                    
                    </div>
                    <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                    
                        <div *ngIf="lineChartData.length>0" class="col-md-12">
                            <div id="cleaverChart2" style="display: block">
                                <canvas baseChart
                                    [datasets]="lineChartData"
                                    [labels]="barChartLabels"
                                    [options]="barChartOptionsCleaver"
                                    [legend]="barChartLegend"
                                    [chartType]="lineChartType"
                                    [height]="300"
                                    >
                                </canvas>
                                <p class="text-center mb-1"><b><small><b>Motivación en el puesto</b></small></b></p>
                                <p class="text-center" ><small>Comportamiento proyectado. Es el estilo mas permanente.</small></p>
                            </div>
                        </div>
                    
                    </div>
                    <div class="col-md-4 justify-content-center m-b-30 m-t-30">
                    
                        <div *ngIf="lineChartData.length>0" class="col-md-12">
                            <div id="cleaverChart3" style="display: block">
                                <canvas baseChart
                                    [datasets]="lineChartData2"
                                    [labels]="barChartLabels2"
                                    [options]="barChartOptionsCleaver"
                                    [legend]="barChartLegend"
                                    [chartType]="lineChartType"
                                    [height]="300"
                        
                                    >
                                </canvas>
                                <p class="text-center mb-1"><b><small><b>Limitaciones del comportamiento en el puesto</b></small></b></p>
                                <p class="text-center" ><small>Estilo básico natural. Es el estilo menos permanente.</small></p>
                            </div>
                        </div>
                    
                    </div>


                </div>


                <p>
                    La calificación obtenida en la descripción del puesto y el comportamiento refleja el nivel de
                    <b>empuje, influencia, constancia y apego</b> que requiere el puesto y el nivel de los factores que
                    tiene la persona. Según los datos que se tengan, la interpretación sobre la compatibilidad
                    varía.
                </p>

                <div class="row mt-5">

                    <div *ngIf="cleaverOriginalScores" class="col-md-6">
                        <h4 class="question-container">
                            <span class="question-number">RESULTADOS PRUEBA </span>
                        </h4>
                        <div class="">
                            <table class="custom-table">
                                <thead>
                                    <tr>
                                        <th class="f-bold text-primary">ESTADO</th>
                                        <th class="f-bold text-primary">D</th>
                                        <th class="f-bold text-primary">I</th>
                                        <th class="f-bold text-primary">S</th>
                                        <th class="f-bold text-primary">C</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="f-bold text-primary">M</td>
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.m.d | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.m.i | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.m.s | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.m.c | number: '1.0-0'}}</td>         
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">L</td>
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.l.d | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.l.i | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.l.s | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.l.c | number: '1.0-0'}}</td>         
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">TOT</td>
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.t.d | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.t.i | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.t.s | number: '1.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverOriginalScores.t.c | number: '1.0-0'}}</td>         
                                    </tr>
        
        
                                </tbody>
                            </table>
                        </div>
                    </div>
                
                    
                    <div *ngIf="cleaverScores" class="col-md-6">

                                
                        <h4 class="question-container">
                            <span class="question-number">TABLA DE EQUIVALENCIAS </span>
                        </h4>
                        <div class="">
                            <table class="custom-table">
                                <thead>
                                    <tr>
                                        <th class="f-bold text-primary">ESTADO</th>
                                        <th class="f-bold text-primary">D</th>
                                        <th class="f-bold text-primary">I</th>
                                        <th class="f-bold text-primary">S</th>
                                        <th class="f-bold text-primary">C</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="f-bold text-primary">M</td>
                                        <td class="f-bold text-gray">{{cleaverScores.m.d | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.m.i | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.m.s | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.m.c | number: '2.0-0'}}</td>         
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">L</td>
                                        <td class="f-bold text-gray">{{cleaverScores.l.d | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.l.i | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.l.s | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.l.c | number: '2.0-0'}}</td>         
                                    </tr>
                                    <tr>
                                        <td class="f-bold text-primary">TOT</td>
                                        <td class="f-bold text-gray">{{cleaverScores.t.d | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.t.i | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.t.s | number: '2.0-0'}}</td>         
                                        <td class="f-bold text-gray">{{cleaverScores.t.c | number: '2.0-0'}}</td>         
                                    </tr>
        
        
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>


            </div>






            <div id="contentToExport3" #contentToExport3 >

                <h3 class="mt-4 custom-title mb-4 sm-font">
                    <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>PERFIL INTERPRETATIVO</b>
                </h3>

                <div *ngIf="cleaverNormal" class="row">
                    <div class="col-md-12">

                        <h4 class="text-primary"><b>ESTADO NORMAL</b></h4>
                        <!-- <h5><b>En estado normal el evaluado actuará de la siguiente manera:</b></h5> -->
                        <div id="normalHtml" #normalHtml ></div>

        
                            <div class="">
                                <table class="custom-table">
                                    <th class="p-0 f-bold text-primary py-3">Estilo personal</th>

                                    <tbody class="custom-items" >
                                        <tr style="padding: 0;">   
                                            
                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">D</span> 
                                                    {{cleaverNormal.personal.d}}
                                                </small>
                                            </h5>
                                            
                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number mr-1">I </span> {{cleaverNormal.personal.i}}
                                                </small>
                                            </h5>

                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">S</span> 
                                                    {{cleaverNormal.personal.s}}
                                                </small>
                                            </h5>

                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">C</span> 
                                                    {{cleaverNormal.personal.c}}
                                                </small>
                                            </h5>

                                        </tr>
        
                                    </tbody>
                                </table>
                            </div>
        
                            <div class="">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th class="p-0 f-bold text-primary py-3">Conductas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-primary text-center f-bold px-0"><b>{{cleaverNormal.behavior.combination.toUpperCase()}} - {{cleaverNormal.behavior.title}}</b></td>
                                            <td class="f-bold text-gray"><b>{{cleaverNormal.behavior.description}}</b></td>         
                    
                                        </tr>
                                        <tr>
                                            <td class="text-high text-center f-bold px-0">
                                                <div class="row">
                                                    <div class="col-12 text-center">
                                                        <img class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                                    </div>
                                                </div>
                                                {{cleaverNormal.max.tag.toUpperCase()}} - {{cleaverNormal.max.title}}
                                            </td>
                                            <td class="f-bold text-gray">

                                                {{cleaverNormal.max.description}}
                                            
                                            </td>     
                                        </tr>
                                        <tr>
                                            <td class="text-low text-center f-bold px-0">
                                                <div class="row">
                                                    <div class="col-12 text-center">
                                                        <img class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                                    </div>
                                                </div>
                                                {{cleaverNormal.min.tag.toUpperCase()}} - {{cleaverNormal.min.title}}
                                            </td>
                                            <td class="f-bold text-gray">{{cleaverNormal.min.description}}</td>        
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                    </div>
                </div>
            </div>
            <div id="contentToExport4" #contentToExport4 >


                <div *ngIf="cleaverMotivated" class="row">
                    <div class="col-md-12">
                                
                        <h4 class="text-primary mt-4"><b>ESTADO MOTIVADO</b></h4>
                        <!-- <h5><b>En estado motivado el evaluado actuará de la siguiente manera:</b></h5> -->
                        <div id="motivatedHtml" #motivatedHtml ></div>

        
                            <div class="">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th class="p-0 f-bold text-primary py-3">Estilo personal</th>
                                        </tr>
                                    </thead>
                                    <tbody class="custom-items" >
                                        <tr style="padding: 0;">   
                                            
                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">D</span> 
                                                    {{cleaverMotivated.personal.d}}
                                                </small>
                                            </h5>
                                            
                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number mr-1">I </span>  {{cleaverMotivated.personal.i}}
                                                </small>
                                            </h5>

                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">S</span> 
                                                    {{cleaverMotivated.personal.s}}
                                                </small>
                                            </h5>

                                        </tr>
                                        <tr style="padding: 0;">

                                            <h5 >
                                                <small class="question-container">
                                                    <span class="question-number">C</span> 
                                                    {{cleaverMotivated.personal.c}}
                                                </small>
                                            </h5>

                                        </tr>
        
                                    </tbody>

                                </table>
                            </div>
                            <div class="">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th class="p-0 f-bold text-primary py-3">Conductas</th>
                                        </tr>
                                    </thead>
                                    <tbody class="custom-text-sm">
                                        <tr>
                                            <td class="text-primary text-center f-bold px-0">

                                                <b>{{cleaverMotivated.behavior.combination.toUpperCase()}} - {{cleaverMotivated.behavior.title}}</b>
                                            </td>
                                            <td colspan="2" class="f-bold text-gray"><b>{{cleaverMotivated.behavior.description}}</b></td>         
                    
                                        </tr>

                                        <tr>
                                            <td class="text-high text-center f-bold px-0">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <img class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                                    </div>
                                                </div>
                                                {{cleaverMotivated.max.tag.toUpperCase()}} - {{cleaverMotivated.max.title}}

                                            </td>
                                            <td>
                                                <strong class="text-primary f-bold">Desea: </strong>
                                                <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverMaxWishText; index as i">&#9632; {{p}}</p>
                                                
                                            </td>    
                                            <td>
                                                <strong class="text-primary f-bold">Necesita: </strong>
                                                <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverMaxRequireText; index as i">&#9632; {{p}}</p>
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td class="text-low text-center f-bold px-0">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <img class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                                    </div>
                                                </div>
                                                {{cleaverMotivated.min.tag.toUpperCase()}} - {{cleaverMotivated.min.title}}
                                            </td>
                                            <td>
                                                
                                                <strong class="text-primary f-bold">Desea: </strong>
                                                <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverMinWishText; index as i">&#9632; {{p}}</p>
                                                
                                            </td>
                                            <td>
                                                <strong class="text-primary f-bold">Necesita: </strong>
                                                <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverMinRequireText; index as i">&#9632; {{p}}</p>
        
                                            </td>
        
                                        </tr>

                                    </tbody>
                                </table>

                            </div>

                    </div>
                </div>
            </div>

            <div id="contentToExport5" #contentToExport5 >
                <div *ngIf="cleaverPresion" class="row">
                    <div class="col-md-12">

                        <h4 class="text-primary mt-4"><b>ESTADO BAJO PRESIÓN</b></h4>
                        <!-- <h5><b>En estado Presionado el evaluado actuará de la siguiente manera:</b></h5> -->
                        <div id="stressHtml" #stressHtml ></div>
                        
                        <div class="">
                            <table class="custom-table">
                                <thead>
                                    <tr>
                                        <th class="p-0 f-bold text-primary py-3">Estilo personal</th>
                                    </tr>
                                </thead>

                                <tbody class="custom-items" >
                                    <tr style="padding: 0;">   
                                        
                                        <h5 >
                                            <small class="question-container">
                                                <span class="question-number">D</span> 
                                                {{cleaverPresion.personal.d}}
                                            </small>
                                        </h5>
                                        
                                    </tr>
                                    <tr style="padding: 0;">

                                        <h5 >
                                            <small class="question-container">
                                                <span class="question-number mr-1">I </span>  {{cleaverPresion.personal.i}}
                                            </small>
                                        </h5>

                                    </tr>
                                    <tr style="padding: 0;">

                                        <h5 >
                                            <small class="question-container">
                                                <span class="question-number">S</span> 
                                                {{cleaverPresion.personal.s}}
                                            </small>
                                        </h5>

                                    </tr>
                                    <tr style="padding: 0;">

                                        <h5 >
                                            <small class="question-container">
                                                <span class="question-number">C</span> 
                                                {{cleaverPresion.personal.c}}
                                            </small>
                                        </h5>

                                    </tr>

                                </tbody>


                            </table>
                        </div>

                        <div class="">
                            <table class="custom-table">
                                <thead>
                                    <tr>
                                        <th class="p-0 f-bold text-primary py-3">Conductas</th>
                                    </tr>
                                </thead>


                                <tbody>
                                    <tr>
                                        <td class="text-primary text-center f-bold px-0"><b>{{cleaverPresion.behavior.combination.toUpperCase()}} - {{cleaverPresion.behavior.title}}</b></td>
                                        <td colspan="2" class="f-bold text-gray"><b>{{cleaverPresion.behavior.description}}</b></td>         
                
                                    </tr>

                                    <tr>
                                        <td class="text-high text-center f-bold px-0">
                                            <div class="row">
                                                <div class="col-12">
                                                    <img class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                                </div>
                                            </div>
                                            {{cleaverPresion.max.tag.toUpperCase()}} - {{cleaverPresion.max.title}}
                                        </td>
                                        <td>
                                            <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverPresionMaxText; index as i">&#9632; {{p}}</p>
                                            
                                        </td>    

                                    </tr>
                                    <tr>
                                        <td class="text-low text-center f-bold px-0">
                                            <div class="row">
                                                <div class="col-12">
                                                    <img class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                                </div>
                                            </div>
                                            {{cleaverMotivated.min.tag.toUpperCase()}} - {{cleaverMotivated.min.title}}
                                        </td>
                                        <td>
                                            
                                            <p class="f-bold text-gray mb-0" *ngFor="let p of cleaverPresionMinText; index as i">&#9632; {{p}}</p>
                                            
                                        </td>


                                    </tr>

                                </tbody>

                            </table>
                        </div>

                    </div>
                </div>
            </div>
            <div id="contentToExportC" #contentToExportC >

                <h3 class="mt-4 custom-title mb-4">
                    <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>RESPUESTAS</b>
                </h3>
                <div *ngIf="report" class="row">
                    <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-4 col-sm-4 mb-3">
                        <h5 >
                            <small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> 
                                <span *ngIf="r[1]==1" class="card-text text-center"> 1 = + </span> 
                                <span *ngIf="r[2]==1" class="card-text text-center"> 2 = + </span> 
                                <span *ngIf="r[3]==1" class="card-text text-center"> 3 = + </span> 
                                <span *ngIf="r[4]==1" class="card-text text-center"> 4 = + </span> 
                                <span *ngIf="r[1]==2" class="card-text text-center"> 1 = - </span> 
                                <span *ngIf="r[2]==2" class="card-text text-center"> 2 = - </span> 
                                <span *ngIf="r[3]==2" class="card-text text-center"> 3 = - </span> 
                                <span *ngIf="r[4]==2" class="card-text text-center"> 4 = - </span> 
                            </small>
                        </h5>
                    </div>
                </div>

            </div>
            
        </div>  

    </div>



        <!--KOSTIK-->

    <div *ngIf="selectedType=='KOSTIK'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST KOSTICK</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >
        

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
            <div class="description-section" #kostikReport></div>
        
        </div>

        <div #contentToExport2 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO DE NECESIDADES</b>
            </h3>
    
            <div class="row justify-content-center m-b-30 m-t-30">
    
                <div class="col-md-12">
                    <div id="kostickChart1" style="display: block">
                    <canvas baseChart
                        [datasets]="lineChartDataKostik"
                        [labels]="barChartLabels"
                        [options]="barChartOptions"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>


            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO DE PAPELES O ROLES</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
    
            
                <div class="col-md-12">
                    <div id="kostickChart2" style="display: block">
                    <canvas baseChart
                        [datasets]="lineChartDataKostik2"
                        [labels]="barChartLabels2"
                        [options]="barChartOptions"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>

        </div>
        <div id="contentToExport3" #contentToExport3 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO DE NECESIDADES Y ROLES</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
                <div class="col-md-12">
                <div id="kostickChart3" style="display: block">
                    <canvas baseChart
                    [datasets]="radarChartData"
                    [options]="radarChartOptions"
                    [labels]="radarChartLabels"
                    [chartType]="'radar'">
                    </canvas>
                </div>
                </div>
            </div>

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO DE LOS SIETE FACTORES</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
                <div class="col-md-12">
                <div id="kostickChart4" style="display: block">
                    <canvas baseChart
                    [datasets]="radarChartData"
                    [options]="barChartOptions"
                    [labels]="radarChartLabels"
                    [chartType]="'bar'">
                    </canvas>
                </div>
                </div>
            </div>
        </div>

        <div id="contentToExport4" #contentToExport4 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>INTERPRETACIÓN DE DIMENSIONES Y FACTORES</b>
            </h3>

            <div *ngIf="report" >

                        
                <h4 class="question-container">
                    <span class="question-number">Modo de vida </span>
                </h4>
                    <table class="custom-table">
                        <thead>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of modoDeVidaArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'" >
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>
                        <thead>

                            <tr class="no-padding"><td colspan="3">
                                <h4 class="question-container">
                                    <span class="question-number">Naturaleza social </span>
                                </h4>
                            </td></tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of naturalezaSocialArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>
                        <thead>
                            <tr class="no-padding">
                                <td colspan="3">
                                    <h4 class="question-container">
                                        <span class="question-number">Adaptación al trabajo </span>
                                    </h4>
                                </td>
                            </tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of adaptacionAlTrabajoArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>

                        <thead>
                            <tr class="no-padding">
                                <td colspan="3">
                                    <h4 class="question-container">
                                        <span class="question-number">Naturaleza emocional </span>
                                    </h4>
                                </td>
                            </tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of naturalezaEmocionalArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>
                        <thead>
                            <tr class="no-padding"><td colspan="3">
                                <h4 class="question-container">
                                    <span class="question-number">Subordinación </span>
                                </h4>
                            </td></tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of subordinacionArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>
                        <thead>
                            <tr class="no-padding"><td colspan="3">
                                <h4 class="question-container">
                                    <span class="question-number">Grado de energía </span>
                                </h4>
                            </td></tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of gradoDeEnergiaArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>
                        <thead>
                            <tr class="no-padding"><td colspan="3">
                                <h4 class="question-container">
                                    <span class="question-number">Liderazgo </span>
                                </h4>
                            </td></tr>
                            <tr class="no-padding">
                                <th class="f-bold text-primary">Dimensión</th>
                                <th class="f-bold text-primary">Puntaje</th>
                                <th class="f-bold text-primary">Interpretación</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="no-padding" *ngFor="let factor of liderazgoArray">
                                <td class="f-bold text-gray">{{factor.dimension}}</td>
                                <td class="f-bold text-center" [ngClass]="factor.score <= 4? 'text-low': factor.score <= 6? 'text-mid' : 'text-high'">
                                    <div class="row">
                                        <div class="col-12">
                                            <img *ngIf="factor.score <= 4 " class="img-xsm" src="../../../assets/images/level/2.png" alt="">
                                            <img *ngIf="(factor.score > 4 && factor.score <= 6)" class="img-xsm" src="../../../assets/images/level/4.png" alt="">
                                            <img *ngIf="factor.score > 6 " class="img-xsm" src="../../../assets/images/level/6.png" alt="">
                                        </div>
                                    </div>
                                    {{factor.score}}
                                </td>         
                                <td class="f-bold text-gray">{{factor.description}}</td>            
                            </tr> 

                        </tbody>

                    </table>

            </div>

        </div>


        <div id="contentToExport5" #contentToExport5 >

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-4 col-md-3 col-sm-3 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> 
                        <span *ngIf="r=='opcA'" class="card-text text-center"> A</span>
                        <span *ngIf="r=='opcB'" class="card-text text-center"> B</span>
                    </small></h5>
                </div>
            </div>
        
        </div>
        <div id="contentToExport5" #contentToExport5 class="p-30"></div>

        
    </div>

        <!--IPV-->

    <div *ngIf="selectedType=='IPV'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST IPV</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >
            
            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
            <div class="description-section" #ipvReport></div>

        </div>

        <div id="contentToExport2" #contentToExport2 >

            <h3 class=" custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row">

                <div class="col-md-12">
                    <div id="ipvChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsIpv"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>

            </div>

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>TABLA INTERPRETATIVA</b>
            </h3>


                <table *ngIf="report" class="custom-table">
                    <thead>
                        <tr>
                            <th class="text-gray f-bold">Descripción</th>
                            <th class="text-gray f-bold">Escala</th>
                            <th class="text-gray f-bold">PN</th>
                            <th class="text-gray f-bold">PE</th>
                            <th class="text-gray f-bold text-center">Calificación</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td colspan="5" >
                                <h4 class="question-container">
                                    <span class="question-number">Dimensiones generales </span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold" >Disposición general a la venta</td>
                            <td>DGV</td>         
                            <td>{{report.directScore.DGV}}</td>         
                            <td>{{report.naturalScore.DGV}}</td>         
                            <td *ngIf="report.naturalScore.DGV<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.DGV>=5&&report.naturalScore.DGV<=6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.DGV>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Receptividad</td>
                            <td>R</td>         
                            <td>{{report.directScore.R}}</td>         
                            <td>{{report.naturalScore.R}}</td>         
                            <td *ngIf="report.naturalScore.R<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.R>=5&&report.naturalScore.R<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.R>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Agresividad</td>
                            <td>A</td>         
                            <td>{{report.directScore.A}}</td>         
                            <td>{{report.naturalScore.A}}</td>         
                            <td *ngIf="report.naturalScore.A<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.A>=5&&report.naturalScore.A<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.A>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td colspan="5" >
                                <h4 class="question-container">
                                    <span class="question-number">Rasgos de personalidad </span>
                                </h4>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold" >Comprensión</td>
                            <td>I</td>         
                            <td>{{report.directScore.I}}</td>         
                            <td>{{report.naturalScore.I}}</td>         
                            <td *ngIf="report.naturalScore.I<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.I>=5&&report.naturalScore.I<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.I>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Adaptabilidad</td>
                            <td>II</td>         
                            <td>{{report.directScore.II}}</td>         
                            <td>{{report.naturalScore.II}}</td>         
                            <td *ngIf="report.naturalScore.II<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.II>=5&&report.naturalScore.II<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.II>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Control de sí mismo</td>
                            <td>III</td>         
                            <td>{{report.directScore.III}}</td>         
                            <td>{{report.naturalScore.III}}</td>         
                            <td *ngIf="report.naturalScore.III<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.III>=5&&report.naturalScore.III<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.III>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Tolerancia a la frustración</td>
                            <td>IV</td>         
                            <td>{{report.directScore.IV}}</td>         
                            <td>{{report.naturalScore.IV}}</td>         
                            <td *ngIf="report.naturalScore.IV<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.IV>=5&&report.naturalScore.IV<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.IV>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Combatividad</td>
                            <td>V</td>         
                            <td>{{report.directScore.V}}</td>         
                            <td>{{report.naturalScore.V}}</td>         
                            <td *ngIf="report.naturalScore.V<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.V>=5&&report.naturalScore.V<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.V>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Dominio</td>
                            <td>VI</td>         
                            <td>{{report.directScore.VI}}</td>         
                            <td>{{report.naturalScore.VI}}</td>         
                            <td *ngIf="report.naturalScore.VI<5" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VI>=5&&report.naturalScore.VI<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VI>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Seguridad</td>
                            <td>VII</td>         
                            <td>{{report.directScore.VII}}</td>         
                            <td>{{report.naturalScore.VII}}</td>         
                            <td *ngIf="report.naturalScore.VII<5" >
                                                                            <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VII>=5&&report.naturalScore.VII<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VII>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Actividad</td>
                            <td>VIII</td>         
                            <td>{{report.directScore.VIII}}</td>         
                            <td>{{report.naturalScore.VIII}}</td>         
                            <td *ngIf="report.naturalScore.VIII<5" >
                                                                            <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VIII>=5&&report.naturalScore.VIII<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.VIII>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 
                        <tr>
                            <td class="text-primary f-bold" >Sociabilidad</td>
                            <td>IX</td>         
                            <td>{{report.directScore.IX}}</td>         
                            <td>{{report.naturalScore.IX}}</td>         
                            <td *ngIf="report.naturalScore.IX<5" >
                                                                            <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/2.png">
                                    </div>
                                </div>
                                <div class="col-12 text-low f-bold text-center">
                                    Bajo
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.IX>=5&&report.naturalScore.IX<=6" >
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/4.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-mid text-center">
                                    Promedio
                                </div>
                            </td>         
                            <td *ngIf="report.naturalScore.IX>6" > 
                                <div class="col-12">
                                    <div class="row jcc">
                                        <img class="img-xsm" src="../../../assets/images/level/6.png">
                                    </div>
                                </div>
                                <div class="col-12 f-bold text-high text-center">
                                    Alto
                                </div>
                            </td>         
                        </tr> 

                    </tbody>
                </table>
                <h4 class="question-container">
                </h4>
                <h6 class="text-primary f-bold">PN (Puntuación Natural)</h6>
                <h6 class="text-primary f-bold m-b-20">PE (Puntuación Estándar)</h6>

        </div>

        <div id="contentToExport3" #contentToExport3 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>
            
            <div class="row">
        
                <div *ngFor="let f of ipvArray; index as i" class="col-12">
                    <h4 *ngIf="i == 0" class="question-container">
                        <span class="question-number">DIMENSIONES GENERALES </span>
                    </h4>
                    <h4 *ngIf="f.title.indexOf('I -') == 0" class="question-container">
                        <span class="question-number">DIMENSIONES ESPECÍFICAS DE RECEPTIVIDAD </span>
                    </h4>
                    <h4 *ngIf="f.title.indexOf('V -') == 0" class="question-container">
                        <span class="question-number">DIMENSIONES ESPECÍFICAS DE AGRESIVIDAD </span>
                    </h4>

                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <h4 class="text-primary f-bold">
                                &#9632; {{f.title}}
                            </h4>
                        </div>
                        <div class="col-12">
                            <p class="text-gray f-bold"><b>{{f.desc}}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        
        </div>
        <div id="contentToExport4" #contentToExport4 >

            <h3 class="custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-2 col-sm-3 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> {{r}}</small></h5>
                </div>
            </div>
        </div>
        <div id="contentToExport5" #contentToExport5 ></div>


        
    </div>


        <!--TERMAN-->


    <div *ngIf="selectedType=='TERMAN'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white sm-font"><b>TEST TERMAN - MERRIL</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >
        

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
                
            </div>
            <div class="description-section" #termanReport></div>
            
            <h4 *ngIf="report" class="mt-4 "><strong class="text-primary">Puntos totales: </strong> <span class="f-bold text-gray">{{termanScore}}</span></h4>
            <h4 *ngIf="report" class=" "><strong class="text-primary">Coeficiente intelectual: </strong><span class="f-bold text-gray">{{termanIq}}</span></h4>
            <h4 *ngIf="report" class=" "><strong class="text-primary">Rango: </strong><span class="f-bold text-gray">{{termanRank}}</span></h4>
            <h4 *ngIf="report" class=" "><strong class="text-primary">Capacidad de aprendizaje: </strong><span class="f-bold text-gray">{{termanCa}}</span></h4>
        </div>
        <div id="contentToExport2" #contentToExport2>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
                <div class="col-md-12">
                    <div id="termanChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsTerman"
                        [legend]="barChartLegend"
                        [chartType]="lineChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>

            <div class="col-12">

                <h3 class="mt-4 custom-title mb-4 sm-font">
                    <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>PUNTUACIONES</b>
                </h3>
                <div class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Serie</th>
                                <th class="text-primary f-bold">Categoría</th>
                                <th class="text-primary f-bold text-center">Puntuación</th>
                                <th class="text-primary f-bold text-center">Rango</th>
    
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of termanArray; index as i">
                                <td class="text-primary f-bold">{{r.serie}}</td>
                                <td class="f-bold text-gray">{{r.category}}</td>
                                <td class="f-bold text-gray text-center">{{r.score}}</td>
                                <td class="f-bold text-gray">
                                    <app-level-widget *ngIf="r.score <= 4" [text]="r.rank" [level]="'1'" [colorClass]="'text-low'" ></app-level-widget>
                                    <app-level-widget *ngIf="r.score >= 5 && r.score <= 6" [text]="r.rank" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                                    <app-level-widget *ngIf="r.score >= 7 && r.score <= 9" [text]="r.rank" [level]="'3'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="r.score >= 10 && r.score <= 14" [text]="r.rank" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="r.score >= 15 && r.score <= 20" [text]="r.rank" [level]="'5'" [colorClass]="'text-mid-high'"></app-level-widget>
                                    <app-level-widget *ngIf="r.score > 20" [text]="r.rank" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                                    
                                </td>
                            </tr>
    
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
        <div id="contentToExport3" #contentToExport3 [style]="isExporting?'padding:2cm;':''">

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>

            <div class="row">
        
                <div *ngFor="let f of termanDescriptionsArray; index as i" class="col-md-12">

                    <div class="row mt-3">
                        <div class="col-md-4 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary text-gray"><b>{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <p class="text-gray f-bold"><b>&#9632; {{f.desc}}</b></p>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>

        <div id="contentToExport4" #contentToExport4 >


            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of termanAnswers; index as i" class="col-12 col-md-4 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> {{r.toUpperCase()}} {{!r?'SIN RESPONDER':''}}</small></h5>
                </div>
            </div>

        </div>


    </div>

    <!--ZAVIC-->

    <div *ngIf="selectedType=='ZAVIC'" class="card col-md-10 col-lg-8 p-4 p-md-5">

        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST ZAVIC</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport >
    
            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
        </div>

        <div class="description-section" #zavicReport></div>

        <div id="contentToExport2" #contentToExport2>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
            
                <div class="col-md-12">
                    <div id="zavicChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsZavic"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
            
                        >
                    </canvas>
                    </div>
                </div>
            
            </div>

        </div>

        <div id="contentToExport3" #contentToExport3 >

            <h3 class="mt-4 custom-title mb-4 sm-font">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>

            <h4 class="question-container">
                <span class="question-number">VALORES </span>
            </h4>
            <div class="row">

                <div *ngFor="let f of zavicArray" class="col-12">

                    <div class="row mt-3">
                        <div class="col-md-4 mb-2">
                            <app-level-widget *ngIf="f.title.indexOf('BAJO') > -1" [text]="f.title" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                            <app-level-widget *ngIf="f.title.indexOf('PROMEDIO') > -1" [text]="f.title" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                            <app-level-widget *ngIf="f.title.indexOf('ALTO') > -1" [text]="f.title" [level]="'6'" [colorClass]="'text-high'" ></app-level-widget>
                        </div>
                        <div class="col-md-8">
                            <p class="text-gray f-bold"><b>&#9632; {{f.desc}}</b></p>
                        </div>
                    </div>

                </div>
            </div>

            <h4 class="question-container">
                <span class="question-number">INTERESES </span>
            </h4>

            <div class="row">
                <div *ngFor="let f of zavicArray1" class="col-12">
                    <div class="row mt-3">
                        <div class="col-md-4 mb-2">
                            <app-level-widget *ngIf="f.title.indexOf('BAJO') > -1" [text]="f.title" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                            <app-level-widget *ngIf="f.title.indexOf('PROMEDIO') > -1" [text]="f.title" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                            <app-level-widget *ngIf="f.title.indexOf('ALTO') > -1" [text]="f.title" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                        </div>
                        <div class="col-md-8">
                            <p class="text-gray f-bold"><b>&#9632; {{f.desc}}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="contentToExport4" #contentToExport4>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-12 col-md-6 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> A - {{r[1]}} B - {{r[2]}} C - {{r[3]}} D - {{r[4]}}</small></h5>
                </div>
            </div>

        </div>

    </div>

    <!--MMPI2-->

    <div *ngIf="selectedType=='MMPI2'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST MMPI-2</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>
        
            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>

            </div>

            <div class="description-section" #mmpi2Report></div>

            <div class="row">
                <div class="col-12 my-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/check-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>VALIDACIÓN</b>
                    </h3>
                </div>
            </div>
            <h4 *ngIf="!isLoading"[ngClass]="(mmpi2Results['?'].value<30&&mmpi2Results['F'].value<80&&mmpi2Results['L'].value<79&&mmpi2Results['K'].value<70)?'text-success':'text-danger'" class="card-title">
                <b>{{(mmpi2Results['?'].value<30&&mmpi2Results['F'].value<80&&mmpi2Results['L'].value<79&&mmpi2Results['K'].value<70)?'Perfil válido':'Perfil inválido'}}</b>
            </h4>
            <h5 *ngIf="selectedTest.extra!='Abreviado'&&mmpi2Results&&mmpi2Results['FB'].value>110" class="card-title text-danger">
                <b>Interpretaciónes de escalas suplementarias y de contenido inválidas</b>
            </h5>
            <div *ngIf="mmpi2Results" class="">
                <table class="custom-table">
                    <tbody>
                        <tr>
                            <td class="text-primary f-bold">Sin responder</td>
                            <td *ngIf="mmpi2Results['?'].value<30">
                                <app-level-widget [text]="mmpi2Results['?'].pd" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            </td>
                            <td *ngIf="mmpi2Results['?'].value>=30">
                                <app-level-widget [text]="mmpi2Results['?'].pd" [level]="'2'" [colorClass]="'text-low'" ></app-level-widget>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">Incoherencia</td>
                            <td *ngIf="mmpi2Results['F'].value<80">
                                <app-level-widget [text]="mmpi2Results['F'].pd" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            </td>
                            <td *ngIf="mmpi2Results['F'].value>=80">
                                <app-level-widget [text]="mmpi2Results['F'].pd" [level]="'2'" [colorClass]="'text-low'" ></app-level-widget>
                            </td>
                        </tr>
                        <tr *ngIf="selectedTest.extra!='Abreviado'">
                            <td class="text-primary f-bold">Incoherencia posterior</td>
                            <td *ngIf="mmpi2Results['FB'].value<80">
                                <app-level-widget [text]="mmpi2Results['FB'].pd" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            </td>
                            <td *ngIf="mmpi2Results['FB'].value>=80">
                                <app-level-widget [text]="mmpi2Results['FB'].pd" [level]="'2'" [colorClass]="'text-low'" ></app-level-widget>
                            </td>

                        </tr>
                        <tr>
                            <td class="text-primary f-bold">Mentira</td>
                            <td *ngIf="mmpi2Results['L'].value<79">
                                <app-level-widget [text]="mmpi2Results['L'].pd" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            </td>
                            <td *ngIf="mmpi2Results['L'].value>=79">
                                <app-level-widget [text]="mmpi2Results['L'].pd" [level]="'2'" [colorClass]="'text-low'" ></app-level-widget>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">Corrección</td>
                            <td *ngIf="mmpi2Results['K'].value<70">
                                <app-level-widget [text]="mmpi2Results['K'].pd" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            </td>
                            <td *ngIf="mmpi2Results['K'].value>=70">
                                <app-level-widget [text]="mmpi2Results['K'].pd" [level]="'2'" [colorClass]="'text-low'" ></app-level-widget>
                            </td>
                        </tr>
                    </tbody>
                </table>
                
            </div>
        </div>
            
        <div *ngIf="mmpi2Results" id="contentToExport2" #contentToExport2 >
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>
            <div id="chartLg1">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS BÁSICAS </span>
                </h4>
                <div *ngIf="mmpi2Results&&!isLoading" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart1" style="display: block">
                        <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi2"
                            [labels]="barChartLabels"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div id="chartLg2">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS DE CONTENIDO </span>
                </h4>
                <div *ngIf="mmpi2Results&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart2" style="display: block">
                            <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi22"
                            [labels]="barChartLabels2"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedTest.extra!='Abreviado'" id="chartLg3">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS SUPLEMENTARIAS </span>
                </h4>
                <div *ngIf="mmpi2Results&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart3" style="display: block">
                            <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi23"
                            [labels]="barChartLabels3"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div id="chartLg4">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">SUBESCALAS HARRIS-LINGOES </span>
                </h4>
                <div *ngIf="mmpi2Results&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart4" style="display: block">
                            <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi24"
                            [labels]="barChartLabels4"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mmpi2Results&&!isLoading" class="">
            <h3 class="custom-title mb-4">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>ESCALAS</b>
            </h3>


            <div sid="contentToExport3" #contentToExport3 >
                <h4 class="question-container">
                    <span class="question-number">ESCALAS DE VALIDEZ </span>
                </h4>
                <div class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Validez'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h4 class="question-container">
                    <span class="question-number">ESCALAS CLÍNICAS</span>
                </h4>
                <div class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
    
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Clínicas'; index as i">
                                <td class="f-bold text-gray">{{r.scale=='Mf'?evaluated.sex=='Masculino'?'Mf':'Mf':r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="pdfContenido" *ngIf="selectedTest.extra!='Abreviado'">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS DE CONTENIDO </span>
                </h4>

                <div *ngIf="selectedTest.extra!='Abreviado'" class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
    
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Contenido'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="pdfSuplementarias" *ngIf="selectedTest.extra!='Abreviado'">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS SUPLEMENTARIAS </span>
                </h4>
                <div *ngIf="selectedTest.extra!='Abreviado'" class="">
                    <h5 class="text-primary mt-4"><b>Características generales de la personalidad</b></h5>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Suplementarias':'cg'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="selectedTest.extra!='Abreviado'" class="">
                    <h5 class="text-primary mt-4"><b>Malestar emocional generalizado</b></h5>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
    
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Suplementarias':'me'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="selectedTest.extra!='Abreviado'" class="">
                    <h5 class="text-primary mt-4"><b>Descontrol comportamental</b></h5>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
    
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Suplementarias':'dc'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="selectedTest.extra!='Abreviado'" class="">
                    <h5 class="text-primary mt-4"><b>Rol de género</b></h5>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpi2Results | scalePipe:'Suplementarias':'rg'; index as i">
                                <td class="f-bold text-gray">{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
                <div *ngIf="mmpi2Questions.length>0" id="contentToExport4" #contentToExport4 >
                    <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                        <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                    </h4>
                    <h5 class="text-primary mt-4"><b>Escala D</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'D'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-primary mt-4"><b>Escala HY</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
        
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'HY'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-primary mt-4"><b>Escala PD</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
        
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'PD'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div id="contentToExport5" #contentToExport5>
                    <h5 class="text-primary mt-4"><b>Escala PA</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'PA'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-primary mt-4"><b>Escala SC</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'SC'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-primary mt-4"><b>Escala MA</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'MA'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5 class="text-primary mt-4"><b>Escala SI</b></h5>
                    <div class="">
                        <table class="custom-table">
                            <thead>
                                <tr>
                                    <th class="text-primary f-bold">Escala</th>
                                    <th class="text-primary f-bold w-30">Título</th>
                                    <th class="text-primary f-bold text-center">Puntaje directo</th>
                                    <th class="text-primary f-bold text-center">Puntaje T</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let r of mmpi2Results | scalePipe:'Lingoes':'SI'; index as i">
                                    <td class="f-bold text-gray">{{r.scale}}</td>
                                    <td class="f-bold text-gray">{{r.title}}</td>
                                    <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                    <td class="f-bold text-gray text-center">{{r.value}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <h3 class="custom-title my-4 sm-font">
                    <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>PERFIL INTERPRETATIVO</b>
                </h3>
                <div *ngIf="!isLoading&&mmpi2Array.length>0" class="row justify-content-center">
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Validez'; index as i" [attr.id]="f.title" class="col-md-12">
                        <h4 *ngIf="i==0" class="question-container">
                            <span class="question-number">ESCALAS DE VALIDEZ</span>
                        </h4>
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>

                    </div>
                </div>
    
                <div *ngIf="!isLoading&&mmpi2Array.length>0" class="row justify-content-center mt-4">
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Clínicas'; index as i" [attr.id]="f.title" class="col-md-12">
                        <h4 *ngIf="i==0" class="question-container">
                            <span class="question-number">ESCALAS CLÍNICAS</span>
                        </h4>
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div *ngIf="!isLoading&&mmpi2Array.length>0&&selectedTest.extra=='Abreviado'" class="row justify-content-center mt-4">
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'D'; index as i" [attr.id]="f.title" class="col-md-12">
                        <h4 *ngIf="i==0" class="question-container">
                            <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                        </h4>
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'HY'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'PD'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'PA'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'SC'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'MA'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'SI'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div *ngIf="!isLoading&&mmpi2Array.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center mt-4">
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Contenido'; index as i" [attr.id]="f.title" class="col-md-12">
                        <h4 *ngIf="i==0" class="question-container">
                            <span class="question-number">ESCALAS DE CONTENIDO</span>
                        </h4>
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div *ngIf="!isLoading&&mmpi2Array.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center mt-4">
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Suplementarias':'cg'; index as i" [attr.id]="f.title" class="col-md-12">
                        <h4 *ngIf="i==0" class="question-container">
                            <span class="question-number">ESCALAS SUPLEMENTARIAS</span>
                        </h4>
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Suplementarias':'me'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Suplementarias':'dc'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Suplementarias':'rg'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                </div>
    
                <div *ngIf="!isLoading&&mmpi2Array.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center mt-4">
                    <div class="col-12">
                        <h4 class="question-container">
                            <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                        </h4>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'D'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'HY'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'PD'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'PA'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'SC'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'MA'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let f of mmpi2Array | scalePipe:'Lingoes':'SI'; index as i" [attr.id]="f.title" class="col-md-12">
                        <div class="row mt-3">
                            <div class="col-12 mb-2">
                                <div class="row justify-content-center">
                                    <div class="col-12">
                                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div id="MMPI2Perfil">
                    <h3 class="mt-4 custom-title mb-4 sm-font">
                        <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>TRAZADO DE PERFIL</b>
                    </h3>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>Código: {{mmpi2Combination.code}} - Perfil {{mmpi2Combination.definition}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="mmpi2Combination.description | html"></div>
                        </div>
                    </div>

                </div>
        
        
            
                <div *ngIf="report&&!isLoading">
                    <h3 class="mt-4 custom-title mb-4">
                        <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>RESPUESTAS</b>
                    </h3>
                    <div *ngIf="report" class="row">
                        <div *ngFor="let r of report.answers; index as i" class="col-12 col-md-4 mb-3">
                            <h5 >
                                <small class="question-container-r"><span class="question-number-r mr-1">Nº {{i+1}}</span> 
                                    <span *ngIf="r===null" class="card-text text-danger text-center min-margin-bottom"><b><strong>No sé</strong></b></span>
                                    <span *ngIf="r!=null" class="card-text text-center min-margin-bottom">{{r==true?'Verdadero':'Falso'}}</span>
                                </small>
                            </h5>
                        </div>
                    </div>

                    <h3 class="mt-4 custom-title mb-4 sm-font">
                        <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>ÍTEMS SIN RESPONDER</b>
                    </h3>
                    <div *ngIf="report" class="row">
                        <div *ngFor="let r of mmpi2NullAnswers; index as i" class="col-12  mb-3">
                            <h5 >

                            </h5>
                            <p class="text-gray f-bold">
                                <small class=""><span class="question-number mr-1">Nº {{r+1}} </span> 
                                </small>
                                <small>{{mmpi2Questions[r].text}}</small></p>
                        </div>
                    </div>
                </div>

        </div>


    </div>

    <!--MMPIA-->

    <div *ngIf="selectedType=='MMPIA'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST MMPI-A</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
    
            </div>
    
            <div class="description-section" #mmpiaReport></div>
        </div>
        <!-- <div class="row justify-content"><a class="text-center" href="../../../assets/files/Instrucciones-mmpia.pdf" download="Guía MMPIA.pdf"><img src="../../../assets/images/pdf.png" width="50" alt=""><b>DECARGAR GUÍA EN PDF</b></a></div> -->

            
        <div *ngIf="mmpiaResults" >
            <div id="chartLg1">
                <h3 class="mt-4 custom-title mb-4">
                    <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>PERFIL GRÁFICO</b>
                </h3>
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS BÁSICAS </span>
                </h4>
                <div *ngIf="mmpiaResults&&!isLoading" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart1" style="display: block">
                        <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi2"
                            [labels]="barChartLabels"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [height]="300"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div id="chartLg2">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS DE CONTENIDO </span>
                </h4>
                <div *ngIf="mmpiaResults&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart2" style="display: block">
                            <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi22"
                            [labels]="barChartLabels2"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [height]="300"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="selectedTest.extra!='Abreviado'" id="chartLg3">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS SUPLEMENTARIAS </span>
                </h4>
                <div *ngIf="mmpiaResults&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart3" style="display: block">
                            <canvas class="center-block" baseChart
                            [datasets]="barChartDataMmpi23"
                            [labels]="barChartLabels3"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [height]="300"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
            <div id="chartLg4">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">SUBESCALAS HARRIS-LINGOES </span>
                </h4>
                <div *ngIf="mmpiaResults&&!isLoading&&selectedTest.extra!='Abreviado'" class="row justify-content-center m-b-30 m-t-30">       
                    <div class="col-md-12">
                        <div id="pfChart4" style="display: block">
                            <canvas class="center-block" baseChart

                            [datasets]="barChartDataMmpi24"
                            [labels]="barChartLabels4"
                            [options]="barChartOptionsMmpi2"
                            [legend]="barChartLegend"
                            [chartType]="barChartType"
                            >
                        </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="mmpiaResults&&!isLoading">
        
            <h3 class="custom-title mb-4">
                <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                <b>ESCALAS</b>
            </h3>
        
        
            <div>
                <h4 class="question-container">
                    <span class="question-number">ESCALAS DE VALIDEZ </span>
                </h4>
                <div class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Validez'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h4 class="question-container">
                    <span class="question-number">ESCALAS CLÍNICAS</span>
                </h4>
                <div class="">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Clínicas'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale=='Mf'?evaluated.sex=='Masculino'?'Mf':'Mf':r.scale}}
                                </td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="pdfContenido" *ngIf="selectedTest.extra!='Abreviado'">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS DE CONTENIDO </span>
                </h4>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Contenido'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="pdfSuplementarias" *ngIf="selectedTest.extra!='Abreviado'">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">ESCALAS SUPLEMENTARIAS </span>
                </h4>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Suplementarias'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div *ngIf="mmpiaQuestions.length>0">
                <h4 *ngIf="selectedTest.extra!='Abreviado'" class="question-container">
                    <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                </h4>
                <h5 class="text-primary mt-4"><b>Escala D</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'D'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="text-primary mt-4"><b>Escala HI</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'HI'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="text-primary mt-4"><b>Escala DP</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'Dp'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div>
                <h5 class="text-primary mt-4"><b>Escala PA</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
        
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'PA'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="text-primary mt-4"><b>Escala ES</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'Es'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="text-primary mt-4"><b>Escala MA</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'MA'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="text-primary mt-4"><b>Escala IS</b></h5>
                <div>
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th class="text-primary f-bold">Escala</th>
                                <th class="text-primary f-bold w-30">Título</th>
                                <th class="text-primary f-bold text-center">Puntaje directo</th>
                                <th class="text-primary f-bold text-center">Puntaje T</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of mmpiaResults | scaleMmpia:'Lingoes':'Is'; index as i">
                                <td class="f-bold text-gray">A-{{r.scale}}</td>
                                <td class="f-bold text-gray">{{r.title}}</td>
                                <td class="f-bold text-gray text-center">{{r.pd}}</td>
                                <td class="f-bold text-gray text-center">{{r.value}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        
        </div>
        
        <div>
            <h3 class="custom-title my-4 sm-font">
                <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL INTERPRETATIVO</b>
            </h3>
            <div *ngIf="!isLoading&&mmpiaArray.length>0" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Validez'; index as i" [attr.id]="f.title" class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">ESCALAS DE VALIDEZ</span>
                    </h4>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div *ngIf="!isLoading&&mmpiaArray.length>0" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Clínicas'; index as i" [attr.id]="f.title" class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">ESCALAS CLÍNICAS</span>
                    </h4>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div *ngIf="!isLoading&&mmpiaArray.length>0&&selectedTest.extra=='Abreviado'" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'D'; index as i" [attr.id]="f.title" class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                    </h4>
                    <p *ngIf="i==0" class="f-bold text-black">
                        Las subescalas de Harris-Lingoes no deben emplearse para interpretar ninguna escala clínica con elevaciones de puntuación T < 60 y, en general, son menos útiles para interpretar las escalas básicas que muestran elevaciones extremas, puesto que todas las áreas de contenido suelen confirmarse de manera sólida cuando las escalas clínicas básicas son marcadamente elevadas. Además, las subescalas necesitan elevarse a un nivel de puntuación T de 65 o más para que se consideren interpretables. También debe recordarse que muchas de las subescalas de Harris-Lingoes son muy breves: algunas sólo contienen seis reactivos. La confiabilidad de muchas de las subescalas de Harris-Lingoes comúnmente es baja, y éstas nunca deben utilizarse como una fuente de información independiente sobre el adolescente, sino que es preciso derivar la interpretación principalmente de las escalas clínicas básicas para la evaluación y comprensión de un adolescente.
                    </p>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'HI'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Dp'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'PA'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Es'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'MA'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Is'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div *ngIf="!isLoading&&mmpiaArray.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Contenido'; index as i" [attr.id]="f.title" class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">ESCALAS DE CONTENIDO</span>
                    </h4>
                    <p *ngIf="i==0" class="text-black f-bold">Las puntuaciones T ≥ 65 son elevadas en términos clínicos, en tanto que las puntuaciones T de entre 60 y 64 son marginalmente elevadas.</p>

                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div *ngIf="!isLoading&&mmpiaArray.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Suplementarias'; index as i" [attr.id]="f.title"
                    class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">ESCALAS SUPLEMENTARIAS</span>
                    </h4>
                    <p *ngIf="i==0" class="f-bold text-black">Solo mencionamos los indicadores centrales de las puntuaciones iguales o superiores a un puntaje T ≥ 65, ya que hay pocas investigaciones concretadas sobre la interpretación de las puntuaciones bajas del inventario MMPI-A.</p>
                    <p *ngIf="i==0" class="f-bold text-black">ADVERTENCIA: Los resultados obtenidos mediante las escalas suplementarias deben ser utilizados para refinar y no para suplantar o remplazar las interpretaciones obtenidas mediante las escalas básicas. Como su nombre lo indica, estas escalas son suplementarias y deben ser utilizadas como herramientas más específicas dentro del marco general de las escalas básicas clínicas y de contenido.</p>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div *ngIf="!isLoading&&mmpiaArray.length>0&&selectedTest.extra!='Abreviado'" class="row justify-content-center">
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'D'; index as i" [attr.id]="f.title" class="col-md-12">
                    <h4 *ngIf="i==0" class="question-container">
                        <span class="question-number">SUBESCALAS HARRIS-LINGOES</span>
                    </h4>
                    <p *ngIf="i==0" class="f-bold text-black">
                        Las subescalas de Harris-Lingoes no deben emplearse para interpretar ninguna escala clínica con elevaciones de puntuación T < 60 y, en general, son menos útiles para interpretar las escalas básicas que muestran elevaciones extremas, puesto que todas las áreas de contenido suelen confirmarse de manera sólida cuando las escalas clínicas básicas son marcadamente elevadas. Además, las subescalas necesitan elevarse a un nivel de puntuación T de 65 o más para que se consideren interpretables. También debe recordarse que muchas de las subescalas de Harris-Lingoes son muy breves: algunas sólo contienen seis reactivos. La confiabilidad de muchas de las subescalas de Harris-Lingoes comúnmente es baja, y éstas nunca deben utilizarse como una fuente de información independiente sobre el adolescente, sino que es preciso derivar la interpretación principalmente de las escalas clínicas básicas para la evaluación y comprensión de un adolescente.
                    </p>
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'HI'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Dp'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'PA'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Es'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'MA'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let f of mmpiaArray | scaleMmpia:'Lingoes':'Is'; index as i" [attr.id]="f.title" class="col-md-12">
                    <div class="row mt-3">
                        <div class="col-12 mb-2">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <h4 class="m-b-0 text-primary f-bold"><b>A-{{f.title}}</b></h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="f.desc | html"></div>
                        </div>
                    </div>
                </div>
            </div>
        
            <div id="MMPI2Perfil">
                <h3 class="mt-4 custom-title mb-4 sm-font">
                    <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>TRAZADO DE PERFIL</b>
                </h3>
                <div class="row mt-3">
                    <div class="col-12 mb-2">
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <h4 class="m-b-0 text-primary f-bold"><b>Código: {{mmpiaCombination.code}} - Perfil
                                        {{mmpiaCombination.definition}}</b></h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div [attr.id]="'desc'+i" class="text-gray f-bold" [innerHTML]="mmpiaCombination.description | html">
                        </div>
                    </div>
                </div>
            </div>
        
        
        
            <div *ngIf="report&&!isLoading">
                <h3 class="mt-4 custom-title mb-4">
                    <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>RESPUESTAS</b>
                </h3>
                <div *ngIf="report" class="row">
                    <div *ngFor="let r of report.answers; index as i" class="col-12 col-md-4 mb-3">
                        <h5>
                            <small class="question-container-r"><span class="question-number-r mr-1">Nº {{i+1}}</span>
                                <span *ngIf="r===null" class="card-text text-danger text-center min-margin-bottom"><b><strong>No
                                            sé</strong></b></span>
                                <span *ngIf="r!=null"
                                    class="card-text text-center min-margin-bottom">{{r==true?'Verdadero':'Falso'}}</span>
                            </small>
                        </h5>
                    </div>
                </div>
        
                <h3 class="mt-4 custom-title mb-4 sm-font">
                    <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>ÍTEMS SIN RESPONDER</b>
                </h3>
                <div *ngIf="report" class="row">
                    <div *ngFor="let r of mmpi2NullAnswers; index as i" class="col-12  mb-3">
                        <h5>
        
                        </h5>
                        <p class="text-gray f-bold">
                            <small class=""><span class="question-number mr-1">Nº {{r+1}} </span>
                            </small>
                            <small>{{mmpi2Questions[r].text}}</small>
                        </p>
                    </div>
                </div>
            </div>
        
        </div>
    </div>
    <!--MPIS-->

    <div *ngIf="selectedType=='MIPS'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST MIPS</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>
        
            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
            <div class="description-section" #mipsReport></div>
        
        </div>

        <div id="mipsTable">
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/table.svg" alt="" class="svg-primary">
                <b>TABLA DE PUNTAJES</b>
            </h3>

            <h4 class="question-container">
                <span class="question-number">METAS MOTIVACIONALES</span>
            </h4>

            <div *ngIf="mipsArray.length>0" >
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="text-gray f-bold" style="width: 450px;">Escalas</th>
                            <th class="text-gray f-bold text-center">% de ítems</th>

                            <th class="text-gray f-bold text-center">Puntaje directo</th>
                            <th class="text-gray f-bold text-center">Puntaje de prevalencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of mipsArray | mipsScalePipe:true:false:false:false; index as i">
                            <td class="text-primary f-bold">{{r.scale}}</td>
                            <td class="text-primary f-bold text-center" >{{(r.itemsCorrect/r.itemsCount)*100 | number: '1.1-1'}}%</td>
                            <td class="text-primary f-bold text-center">{{r.pd}}</td>
                            <td class="text-primary f-bold text-center" [ngClass]="getMipsTextColor((r.pp))">{{r.pp}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        
            <h4 class="question-container mt-4">
                <span class="question-number">MODOS COGNITIVOS</span>
            </h4>
            <div *ngIf="mipsArray.length>0" >
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="text-gray f-bold" style="width: 450px;">Escalas</th>
                            <th class="text-gray f-bold text-center" >% de ítems</th>
                            <th class="text-gray f-bold text-center">Puntaje directo</th>
                            <th class="text-gray f-bold text-center">Puntaje de prevalencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of mipsArray | mipsScalePipe:false:true:false:false; index as i">
                            <td class="text-primary f-bold">{{r.scale}}</td>
                            <td class="text-primary f-bold text-center" >{{(r.itemsCorrect/r.itemsCount)*100 | number: '1.1-1'}}%</td>
                            <td class="text-primary f-bold text-center">{{r.pd}}</td>
                            <td class="text-primary f-bold text-center" [ngClass]="getMipsTextColor((r.pp))">{{r.pp}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div id="mipsTable2">
            <h4 class="question-container mt-4">
                <span class="question-number">CONDUCTAS INTERPERSONALES</span>
            </h4>
            <div *ngIf="mipsArray.length>0">
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="text-gray f-bold" style="width: 450px;">Escalas</th>
                            <th class="text-gray f-bold text-center" >% de ítems</th>

                            <th class="text-gray f-bold text-center">Puntaje directo</th>
                            <th class="text-gray f-bold text-center">Puntaje de prevalencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of mipsArray | mipsScalePipe:false:false:true:false; index as i">
                            <td class="text-primary f-bold">{{r.scale}}</td>
                            <td class="text-primary f-bold text-center">{{(r.itemsCorrect/r.itemsCount)*100 | number: '1.1-1'}}%</td>
                            <td class="text-primary f-bold text-center">{{r.pd}}</td>
                            <td class="text-primary f-bold text-center" [ngClass]="getMipsTextColor((r.pp))" >{{r.pp}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h4 class="question-container mt-4">
                <span class="question-number">VALIDEZ</span>
            </h4>
            <div *ngIf="mipsArray.length>0" >
                <table class="custom-table">
                    <thead>
                        <tr>
                            <th class="text-gray f-bold" style="width: 450px;">Escalas</th>
                            <th class="text-gray f-bold text-center">% de ítems</th>

                            <th class="text-gray f-bold text-center">Puntaje directo</th>
                            <th class="text-gray f-bold text-center">Puntaje de prevalencia</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of mipsArray | mipsScalePipe:false:false:false:true; index as i">
                            <td class="text-primary f-bold">{{r.scale}}</td>
                            <td class="text-primary f-bold text-center" >{{(r.itemsCorrect/r.itemsCount)*100 | number: '1.1-1'}}%</td>
                            <td class="text-primary f-bold text-center" [ngClass]="getMipsTextColor((r.pp))">{{r.pd}}</td>
                            <td class="text-primary f-bold text-center">-</td>
                        </tr>
                    </tbody>
                </table>
                <h4 class="mt-3 text-primary f-bold">ÍNDICE DE AJUSTE: {{mipsAjuste}} </h4>
            </div>
        </div>
        <div id="contentToExport2" #contentToExport2>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>

            <div class="row justify-content-center m-b-30 m-t-30">
                <div class="col-md-12">
                    <div id="zavicChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartData"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsMips"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
                        >
                    </canvas>
                    </div>
                </div>
            </div>

        </div>
        <div>
            <div>
                <h3 class="mt-4 custom-title mb-4 sm-font">
                    <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>INTERPRETACIÓN TEXTUAL</b>
                </h3>
                <h4 class="question-container mt-4">
                    <span class="question-number">ESCALAS DE VALIDEZ</span>
                </h4>
                <div *ngFor="let f of mipsValidezArray; index as i" [attr.id]="f.title" class="row">
                    <div class="col-12">
                        <h4 class="text-primary f-bold mt-3"><b>{{f.title}}</b></h4>
                    </div>
                    <div class="col-12 text-gray f-bold" [innerHTML]="f.desc | html"></div>
                </div>
            </div>

            <div>
                <h4 class="question-container mt-4">
                    <span class="question-number">METAS MOTIVACIONALES</span>
                </h4>
                <div *ngFor="let f of mipsMotivacionalesArray; index as i" [attr.id]="f.title" class="row">
                    <div class="col-12">
                        <h4 class="text-primary f-bold mt-3"><b>{{f.title}}</b></h4>
                    </div>
                    <div class="col-12 text-gray f-bold" [innerHTML]="f.desc | html"></div>
                </div>
            </div>
            <div >
                <h4 class="question-container mt-4">
                    <span class="question-number">MODOS COGNITIVOS</span>
                </h4>
                <div *ngFor="let f of mipsCognitivosArray; index as i" [attr.id]="f.title" class="row">
                    <div class="col-12">
                        <h4 class="text-primary f-bold mt-3"><b>{{f.title}}</b></h4>
                    </div>
                    <div class="col-12 text-gray f-bold" [innerHTML]="f.desc | html"></div>
                </div>
            </div>
            <div >
                <h4 class="question-container mt-4">
                    <span class="question-number">CONDUCTAS INTERPERSONALES</span>
                </h4>
                <div *ngFor="let f of mipsInterpersonalesArray; index as i" [attr.id]="f.title" class="row">
                    <div class="col-12">
                        <h4 class="text-primary f-bold mt-3"><b>{{f.title}}</b></h4>
                    </div>
                    <div class="col-12 text-gray f-bold" [innerHTML]="f.desc | html"></div>
                </div>
            </div>
        </div>

        <div id="contentToExport3" #contentToExport3>
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-12 col-md-4 mb-3">
                    <h5 ><small class="question-container-r"><span class="question-number-r">Nº {{i+1}}</span> {{r?'Verdadero':'Falso'}}</small></h5>
                </div>
                <!-- <div *ngFor="let r of report.answers; index as i" class="col-md-2">
                    
                    <div *ngIf="i<=95" class="card" style="margin-bottom: 5px;" [ngClass]="!r?'card-outline-danger':'card-outline-info'">
                        <div class="card-header min-padding">
                            <h5 class="m-b-0 text-white text-center"><small>Nº {{i+1}}</small></h5></div>
                        <div class="card-body min-padding">
                            <p class="card-text text-center" [ngClass]="!r?'text-danger':''" ><small>{{r?'Verdadero':'Falso'}}</small></p>
                        </div>
                    </div>
                </div> -->
            </div>

        </div>
        
    </div>

    <!--BIS 11-->

    <div *ngIf="selectedType=='BIS11'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST BIS-11</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>

        <div id="contentToExport2" #contentToExport2>
            <div id="bis11Table" >
                <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

                    <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                        <div class="col-12 mb-4">
                            <h3 class="custom-title">
                                <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                                <b>DATOS PERSONALES</b>
                            </h3>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                        </div>
                        <div class="col-12">
                            <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                            <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                        </div>

                        
                    </div>
                    <div class="description-section" #bis11Report></div>

                </div>
                <h3 class="mt-4 custom-title mb-4">
                    <img src="../../../assets/images/icon/table.svg" alt="" class="svg-primary">
                    <b>TABLA DE RESULTADOS</b>
                </h3>
                <div *ngIf="bis11Results" class="">
                    <table class="custom-table">
                        <tbody>
                            <tr>
                                <td class="text-primary f-bold">IMPULSIVIDAD NO PLANEADA</td>
                                <td class="text-gray f-bold">
                                    <app-level-widget *ngIf="bis11Results['No planificada']<=10" [text]="bis11Results['No planificada']" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['No planificada']>10 && bis11Results['No planificada']<=21" [text]="bis11Results['No planificada']" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['No planificada']>21" [text]="bis11Results['No planificada']" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-primary f-bold">IMPULSIVIDAD MOTORA</td>
                                <td class="text-gray f-bold">
                                    <app-level-widget *ngIf="bis11Results['Motora']<=13" [text]="bis11Results['Motora']" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Motora']>13 && bis11Results['Motora']<=27" [text]="bis11Results['Motora']" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Motora']>28" [text]="bis11Results['Motora']" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                            
                                </td>
                            </tr>
                            <tr>
                                <td class="text-primary f-bold">IMPULSIVIDAD COGNITIVA</td>
                                <td class="text-gray f-bold">
                                    <app-level-widget *ngIf="bis11Results['Cognitiva']<=16" [text]="bis11Results['Cognitiva']" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Cognitiva']>16 && bis11Results['Cognitiva']<=33" [text]="bis11Results['Cognitiva']" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Cognitiva']>33" [text]="bis11Results['Cognitiva']" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>

                                </td>
                            </tr>
                            <tr>
                                <td class="text-gray f-bold"><b>TOTAL</b></td>
                                <td class="text-gray f-bold">
                                    <app-level-widget *ngIf="bis11Results['Puntuación total']<=40" [text]="bis11Results['Puntuación total']" [level]="'2'" [colorClass]="'text-low'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Puntuación total']>40 && bis11Results['Puntuación total']<=80" [text]="bis11Results['Puntuación total']" [level]="'4'" [colorClass]="'text-mid'"></app-level-widget>
                                    <app-level-widget *ngIf="bis11Results['Puntuación total']>80" [text]="bis11Results['Puntuación total']" [level]="'6'" [colorClass]="'text-high'"></app-level-widget>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div id="contentToExport3" #contentToExport3 >
            <div class="row">
                <div *ngFor="let f of bis11Array; index as i" [attr.id]="f.title" class="col-12">
                    <h3 *ngIf="i==0" class="mt-4 custom-title mb-4 xsm-font">
                        <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>INTERPRETACIÓN DE SUBESCALAS</b>
                    </h3>
                    <h3 *ngIf="i==3" class="mt-4 custom-title mb-4 sm-font">
                        <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>PERFIL INTERPRETATIVO</b>
                    </h3>

                    <div class="col-12 mt-4">
                        <h4 class="m-b-0 text-primary f-bold"><b>{{f.title}}</b></h4>
                    </div>
                    <div class="col-12">
                        <div class="small-font" [innerHTML]="f.desc | html"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <h3 class="mt-4 custom-title mb-4 xsm-font">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS SEGÚN GRADO</b>
            </h3>

            <h4 class="question-container">
                <span class="question-number">Raramente o nunca</span>
            </h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of bis11NuncaArray; index as i" class="col-12">
                    <p class="text-gray f-bold">
                        <spam class="text-primary">Nº {{r.number}}: </spam>
                        {{r.question}}
                    </p>

                </div>
            </div>
            
            
            <h4 class="question-container">
                <span class="question-number">Ocasionalmente </span>
            </h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of bis11OcasionalmenteArray; index as i" class="col-12">
                    <p class="text-gray f-bold">
                        <spam class="text-primary">Nº {{r.number}}: </spam>
                        {{r.question}}
                    </p>
                </div>
            </div>

            <h4 class="question-container">
                <span class="question-number">A menudo </span>
            </h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of bis11AMenudoArray; index as i" class="col-12">
                    <p class="text-gray f-bold">
                        <spam class="text-primary">Nº {{r.number}}: </spam>
                        {{r.question}}
                    </p>
                </div>
            </div>            
            
            <h4 class="question-container">
                <span class="question-number">Siempre o casi siempre </span>
            </h4>
            <div *ngIf="report" class="row">
                <div *ngFor="let r of bis11SiempreArray; index as i" class="col-12">
                    <p class="text-gray f-bold">
                        <spam class="text-primary">Nº {{r.number}}: </spam>
                        {{r.question}}
                    </p>
                </div>
            </div>
        
        </div>

    </div>

        <!--CHASIDE-->

    <div *ngIf="selectedType=='CHASIDE'" class="card col-md-10 col-lg-8 p-4 p-md-5">
        <div class="test-title">
            <h1 class="m-b-20 text-center text-white"><b>TEST CHASIDE</b></h1>
            <div class="divider">
                <img src="../../../assets/images/waves.svg" alt="">
            </div>
        </div>
        <div class="mt-5 pt-5" id="contentToExport" #contentToExport>
        
            <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
                <div class="col-12 mb-4">
                    <h3 class="custom-title">
                        <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>DATOS PERSONALES</b>
                    </h3>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
                </div>
                <div class="col-12">
                    <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                    <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
                </div>
        
                
            </div>
            <div class="description-section" #chasideReport></div>
        
        </div>
        <div>

            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/table.svg" alt="" class="svg-primary">
                <b>TABLA DE VALORES</b>
            </h3>
            <div *ngIf="chasideScores" >
                <table class="custom-table">
                    <tbody>
                        <tr>
                            <th class="text-gray f-bold">Actividades profesionales</th>
                            <th class="text-gray f-bold text-center">Puntuación Intereses</th>
                            <th class="text-gray f-bold text-center">Puntuación Aptitudes</th>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">C - ADMINISTRATIVAS Y CONTABLES</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.C}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.C}}</td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">H - HUMANÍSTICAS, CIENCIAS JURÍDICAS, CIENCIAS SOCIALES</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.H}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.H}}</td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">A - ARTÍSTICAS</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.A}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.A}}</td>
                        </tr>
                        <tr>
                            <td class="text-primary f-bold">S - CIENCIAS DE LA SALUD</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.S}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.S}}</td>
                        </tr>
                        <tr>
                            
                            <td class="text-primary f-bold">I - INGENIERIAS, CARRERAS TÉCNICAS Y COMPUTACIÓN</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.I}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.I}}</td>
                        </tr>
                        <tr>
                            
                            <td class="text-primary f-bold">D - DEFENSA Y SEGURIDAD</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.D}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.D}}</td>
                        </tr>
                        <tr>
                            
                            <td class="text-primary f-bold">E - CIENCIAS AGRARIAS, DE LA NATURALEZA, ZOOLÓGICAS Y BIOLÓGICAS</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Intereses.E}}</td>
                            <td class="text-primary f-bold text-center">{{chasideScores.Aptitudes.E}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
                <b>PERFIL GRÁFICO</b>
            </h3>            
            <div class="row justify-content-center m-t-30">
                <div class="col-md-12">
                    <div id="pfChart" style="display: block">
                    <canvas baseChart
                        [datasets]="barChartDataChaside"
                        [labels]="barChartLabels"
                        [options]="barChartOptionsChaside"
                        [legend]="barChartLegend"
                        [chartType]="barChartType"
                        [height]="300"
                        >
                    </canvas>
                    </div>
                </div>
            </div>
        </div>
        
        <div style="padding:1px" id="contentToExport2" #contentToExport3></div>

        <div >

            <div class="row">
                <div class="col-12">
                    <h3 class="mt-4 custom-title mb-4 sm-font">
                        <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
                        <b>PERFIL VOCACIONAL</b>
                    </h3>
                    <p class="text-gray f-bold">&#9632; A cada área, formada por un grupo de carreras afines, corresponde una letra.</p>
                    <p class="text-gray f-bold">&#9632; Considere los tres mayores puntajes obtenidos.</p>
                    <p class="text-gray f-bold">&#9632; Busca en los cuadros las áreas con los intereses y las aptitudes más representativas de cada una.</p>
                </div>
                <div *ngFor="let f of chasideArray; index as i" [attr.id]="f.interpretation.title" class="col-md-12">
                    <p class="f-bold text-primary mt-4">
                            {{f.interpretation.scale}} - {{f.interpretation. title}}
                    </p>
                    <div class="small-font" [innerHTML]="f.interpretation.text | html">
                </div>
            </div>

        </div>

        <div >
            <h3 class="mt-4 custom-title mb-4">
                <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
                <b>RESPUESTAS</b>
            </h3>
            <p class="f-bold"><span class="text-low"> Negativo</span>&nbsp;<span class="text-info">Positivo</span></p>

            <div *ngIf="report" class="row">
                <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-3 mb-3">
                    <h5 ><small [ngClass]="r?'question-container-r':'question-container-red'"><span [ngClass]="r?'question-number-r':'question-number-red'">Nº {{i+1}}</span> {{r?'Si':'No'}}</small></h5>
                </div>
            </div>

        </div>
    </div>

    </div>

        <!-- DOMINO -->

    <div *ngIf="selectedType=='DOMINO'" class="card col-md-10 col-lg-8 p-4 p-md-5">
    <div class="test-title">
        <h1 class="m-b-20 text-center text-white"><b>TEST DOMINÓ</b></h1>
        <div class="divider">
            <img src="../../../assets/images/waves.svg" alt="">
        </div>
    </div>
    <div class="mt-5 pt-5" id="contentToExport" #contentToExport>

        <div *ngIf="evaluated" class="mt-5 mb-4 row profile-data">
            <div class="col-12 mb-4">
                <h3 class="custom-title">
                    <img src="../../../assets/images/icon/person-svgrepo-com.svg" alt="" class="svg-primary">
                    <b>DATOS PERSONALES</b>
                </h3>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Nombre y apellido: </b> </strong><b class="text-gray f-bold">{{evaluated.name}} {{evaluated.surname}}</b></p>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Sexo: </b> </strong><b class="text-gray f-bold">{{evaluated.sex}}</b></p>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Edad: </b> </strong><b class="text-gray f-bold">{{age}}</b></p>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Fecha de nacimiento: </b> </strong><b class="text-gray f-bold">{{evaluated.birthDate | date:'dd/MM/yyyy'}}</b></p>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Fecha de aplicación: </b> </strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'dd/MM/yyyy'}}</b></p>
            </div>
            <div class="col-12">
                <p><strong class="text-primary"><b>&#9632; Hora de inicio: </b> </strong><b class="text-gray f-bold">{{selectedTest.startDate | date:'shortTime'}}</b></p>
                <p><strong class="text-primary"><b>&#9632; Hora de finalización: </b></strong><b class="text-gray f-bold">{{selectedTest.completeDate | date:'shortTime'}}</b></p>
            </div>

            
        </div>

        <div class="description-section" #dominoReport></div>
        <!-- <div class="row jcc">
        <img class="scales-img mt-3" src="../../../assets/images/domino/escalas.png" alt="">
        </div> -->

    </div>
    <!-- <div id="contentToExport2" #contentToExport2 >

        <h3 class="mt-4 custom-title mb-4">
            <img src="../../../assets/images/icon/graph-svgrepo-com.svg" alt="" class="svg-primary">
            <b>PERFIL GRÁFICO</b>
        </h3>

        <div class="row ">
            <div class="col-md-12">
                <div id="pfChart" style="display: block">
                <canvas baseChart
                    [datasets]="barChartData"
                    [labels]="barChartLabels"
                    [options]="barChartOptions"
                    [legend]="barChartLegend"
                    [chartType]="barChartType"
        
                    >
                </canvas>
                </div>
            </div>
        
        </div>
    </div> -->
    <div style="justify-content: center;" id="contentToExport3" #contentToExport3 >

        <h3 class="mt-4 custom-title mb-4 sm-font">
            <img src="../../../assets/images/icon/profile-svgrepo-com.svg" alt="" class="svg-primary">
            <b>PERFIL INTERPRETATIVO</b>
        </h3>
        <div class="row">
        <div class="col-12 col-md-6">
            <h5 class="sm-font"><b>Puntaje directo: {{directScore}}</b></h5>
            <h5 class="sm-font"><b>Percentil: {{naturalScore}}</b></h5>
            <h5 class="sm-font"><b>Tiempo empleado: {{testTime / (1000 * 60) | number: '1.0-0'}} minutos</b></h5>
        </div>
        <div class="col-12 col-md-6">
            <div id="score" class="row justify-content-center">
            <img *ngIf="naturalScore >= 95" class="one-img" src="../../../assets/images/level/6.png" alt="">
            <img *ngIf="naturalScore < 95 && naturalScore >=75" class="one-img" src="../../../assets/images/level/5.png" alt="">
            <img *ngIf="naturalScore < 75 && naturalScore >=50" class="one-img" src="../../../assets/images/level/4.png" alt="">
            <img *ngIf="naturalScore < 50 && naturalScore >=10" class="one-img" src="../../../assets/images/level/3.png" alt="">
            <img *ngIf="naturalScore <= 5" class="one-img" src="../../../assets/images/level/2.png" alt="">
            </div>
            <div class="row jcb px-5">
            <span><b>0</b></span>
            <span class="small" *ngIf="naturalScore >= 95"><b>Superior</b></span>
            <span class="small" *ngIf="naturalScore < 95 && naturalScore >=75"><b>Superior al término medio</b></span>
            <span class="small" *ngIf="naturalScore < 75 && naturalScore >=50"><b>Término medio</b></span>
            <span class="small" *ngIf="naturalScore < 50 && naturalScore >=10"><b>Inferior al término medio</b></span>
            <span class="small" *ngIf="naturalScore <= 5"><b>Deficiente</b></span>
            <span><b>44</b></span>
            </div>
        </div>
        </div>


        <div class="description-section" #dominoFactor></div>






        <!-- <div class="row justify-content-center">

            <div *ngFor="let f of pf16Array; index as i" class="col-md-12">
                <div class="row mt-3">
                    <div class="col-md-2 mb-2">
                        <div class="row justify-content-center">
                            <div class="col-12">
                                <div class="row jcc">
                                    <img class="img-xsm" [src]="f.high?'../../../assets/images/level/6.png':'../../../assets/images/level/2.png'" alt="">
                                </div>
                            </div>
                            <div class="col-12">
                                <h4 [ngClass]="f.high ? 'text-high' : 'text-low'" class="m-b-0 text-center"><b>{{f.title}}</b></h4>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-10">
                        <p class="text-gray f-bold"><b>&#9632; {{f.desc}}</b></p>
                    </div>
                </div>
            </div>
        </div> -->

    </div>

    <div id="contentToExport4" #contentToExport4 >

        <h3 class="mt-4 custom-title mb-4">
            <img src="../../../assets/images/icon/question-svgrepo-com.svg" alt="" class="svg-primary">
            <b>RESPUESTAS</b>
        </h3>
        <p class="f-bold"><span class="text-low"> Negativo</span>&nbsp;<span class="text-info">Positivo</span></p>

        <div *ngIf="report" class="row">
            <div *ngFor="let r of report.answers; index as i" class="col-6 col-md-3 col-sm-3 mb-3">
                <h5 ><small [class]="(dominoQuestions[i].correctValues[0] == r[0] && dominoQuestions[i].correctValues[1] == r[1]) ? 'question-container-r' : 'question-container-red'"><span [class]="(dominoQuestions[i].correctValues[0] == r[0] && dominoQuestions[i].correctValues[1] == r[1]) ? 'question-number-r' : 'question-number-red'">Nº {{i+1}}</span> {{r[0]}} - {{r[1]}}</small></h5>
            </div>
        </div>
    </div>

    <div id="contentToExport5" #contentToExport5 class="p-30"></div>



    </div>

</div>


<div *ngIf="isLoading" class="center-fixed-spinner">
    <img src="assets/images/loading.gif" alt="">
</div>


<div class="modal fade editModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel">Modificar datos de usuario</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div *ngIf="editingUser" class="modal-body">
                <div class="row p-t-20 form-material">
                    <div class="col-md-6">
                        <div class="form-group">
                            <input [readOnly]="true" [(ngModel)]="editingUser.email" type="email"   class="form-control" placeholder="Email">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.name" type="text"  class="form-control" placeholder="Nombre">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.surname" type="text"  class="form-control" placeholder="Apellido">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.country" type="text"  class="form-control" placeholder="País">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.city" type="text"  class="form-control" placeholder="Localidad">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.company" type="text"  class="form-control" placeholder="Empresa">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            
                            <input [(ngModel)]="editingUser.notes" type="text"  class="form-control" placeholder="Observaciones">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group row">
                            
                            <div class="col-10">
                                <input [(ngModel)]="editingUser.birthDate" [value]="newDate"  class="form-control" type="date"  id="example-date-input">
                                <span class="help-block text-muted"><small>Fecha de nacimiento</small></span>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <select class="form-control" [(ngModel)]="editingUser.sex">
                                <option  value="Masculino">Masculino</option>
                                <option  value="Femenino">Femenino</option>
                            </select>
                            <span class="help-block text-muted"><small>Sexo</small></span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <input [(ngModel)]="editingUser.studies" type="text"  class="form-control" placeholder="Grado de estudios">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <input [(ngModel)]="editingUser.phone" type="text"  class="form-control" placeholder="Telefono">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <input [(ngModel)]="password" type="text" class="form-control" placeholder="Contraseña">
                            <button class="btn btn-warning waves-effect" (click)="updatePassword()">Actualizar contraseña</button>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger waves-effect btn-rounded text-left" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-success waves-effect btn-rounded text-left" data-dismiss="modal" (click)="update()">Actualizar</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>


<div id="exportingModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">Procesando...</h4>
            </div>
            <div class="modal-body">
                <p>Convirtiendo documento. Por favor, aguarde.</p>
                <span class="text-info text-center" *ngIf="selectedType=='MMPI2'||selectedType=='MMPIA'||selectedType=='BIS11'||selectedType=='CHASIDE'">{{percentCompleted}}% completado. Por favor, no minimice esta ventana.</span>
                <div class="row justify-content-center m-t-30">
                    <img *ngIf="isExporting" src="../../../assets/images/loading.gif" width="80" class="pull-right" />
                </div>
            </div>

        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div id="userPhotoModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">Foto</h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <img [src]="userPhoto" style="width: 100%; height: auto;" alt="">
            </div>

        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<div id="userListModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
  <div class="modal-dialog modal-sm">
      <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-center" id="myModalLabel">Lista de evaluados</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          </div>
          <div class="modal-body">
              <ul>
                <li *ngFor="let user of userList">{{user}}</li>
              </ul>
          </div>

      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>

<div id="newTagModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel">Nueva etiqueta</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-6">
                <label>Nombre
                  <input [(ngModel)]="newTagName" class="form-control custom-input" type="text" id="example-date-input" placeholder="Nombre de etiqueta">
                </label>
              </div>
              <div class="col-6">
                <label>Color
                  <input [(ngModel)]="newTagColor" class="form-control custom-input" type="color" id="example-date-input">
                </label>
              </div>

              
            </div>
            <button class="btn btn-warning btn-rounded" data-dismiss="modal">Cancelar</button>
            <button class="btn btn-info btn-rounded" (click)="createTag()" >Crear</button>

          </div>

      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>



<div *ngIf="testData" id="formModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel"><b>{{testData.completeForm.title}}</b></h4>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body pb-3 px-3 ">
              <div class="row justify-content center">
                  <div *ngFor="let field of testData.formModel; index as i" class="col-md-12">
                      <div>
                          <p class="mb-1"><small><b>{{i + 1}} - {{field.text}}</b> <span class="points-label">{{getQuestionScore(i)}}</span></small></p>
                          <p><small>{{getTextResponse(testData.formData[i])}}</small></p>
                      </div>
                  </div>
              </div>
              <p class="total-score" ><small><b>Puntaje obtenido: <span [ngClass]="testData.formScore >= testData.completeForm.aprovationScore ? 'text-success' : 'text-warning'">{{testData.formScore}}</span></b></small></p>

            </div>
        </div>
    </div>
</div>

<div id="createReportModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"aria-hidden="true">
  <div class="modal-dialog modal-lg">
      <div class="modal-content">
          <div class="modal-header">
              <h4 class="modal-title" id="myModalLabel"><b>Generar reporte de formularios</b></h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
          </div>
          <div class="modal-body pb-3 px-3 ">
            <div class="row justify-content-center">

              <div class="col-8 mt-3">
                <label>
                  Formularios
                  <select [(ngModel)]="filterTest" class="form-control">
                    <option selected disabled value="">Seleccionar</option>
                    <option *ngFor="let test of filterTests" [value]="test">{{test}}</option>
                  </select>
                </label>
              </div>


              <div class="col-8">
                <label>
                  Seleccionar etiquetas (dejar vacío para seleccionar todas)
                  <select (ngModelChange)="addFilterTag($event)" [(ngModel)]="filterTag" class="form-control">
                    <option selected disabled value="">Seleccionar para agregar</option>
                    <option *ngFor="let tag of filterTags" [value]="tag.name">{{tag.name}}</option>
                  </select>
                </label>
                <p class="mb-1 mt-3"><small>Etiquetas seleccionadas. Click para eliminar</small></p>
                <span *ngFor="let t of filteredTags; index as i" (click)="removeFilteredTag(i)" class="label label-rounded label-info mr-1 pointer" >{{t}}</span>
              </div>



              <div class="col-8 mt-3">
                <label>
                  Fecha de inicio
                  <input type="date" [(ngModel)]="startDateFilter" class="form-control">
                </label>
                <label>
                  Fecha de fin
                  <input type="date" [(ngModel)]="endDateFilter" class="form-control">
                </label>
              </div>

              <div class="col-8 mt-3">
                <div class="demo-switch-title">Solo formularios aprobados</div>
                <div class="switch">
                    <label>
                        <input [(ngModel)]="aprovedFilter" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                      </label>
                </div>
              </div>

              <button [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info waves-effect btn-rounded" (click)="generateFormReport()">Generar</button>


            </div>

          </div>
      </div>
  </div>
</div>


<app-loader *ngIf="loading"></app-loader>